/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.5.6320.21856 (NJsonSchema v8.32.6319.16936) (http://NSwag.org)
// </auto-generated>
//----------------------

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

import { HydrogenAppConfigService } from '../host.config.service';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class LicenseApiService {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.license;
    }

    getLicenseTypes(): Observable<string[]> {
      let url_ = this.baseUrl + "/api/License/GetLicenseTypes";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetLicenseTypes(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetLicenseTypes(response_);
              } catch (e) {
                  return <Observable<string[]>><any>Observable.throw(e);
              }
          } else
              return <Observable<string[]>><any>Observable.throw(response_);
      });
  }

  protected processGetLicenseTypes(response: Response): Observable<string[]> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
              result200 = [];
              for (let item of resultData200)
                  result200.push(item);
          }
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<string[]>(<any>null);
  }

  addLicensesToAccount(data: DeviceLicense, count: number): Observable<boolean> {
      let url_ = this.baseUrl + "/api/License/AddLicensesToAccount?";
      if (count === undefined || count === null)
          throw new Error("The parameter 'count' must be defined and cannot be null.");
      else
          url_ += "count=" + encodeURIComponent("" + count) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(data);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processAddLicensesToAccount(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processAddLicensesToAccount(response_);
              } catch (e) {
                  return <Observable<boolean>><any>Observable.throw(e);
              }
          } else
              return <Observable<boolean>><any>Observable.throw(response_);
      });
  }

  protected processAddLicensesToAccount(response: Response): Observable<boolean> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<boolean>(<any>null);
  }

  updateAccountLicenses(data: DeviceLicense, count: number): Observable<boolean> {
      let url_ = this.baseUrl + "/api/License/UpdateAccountLicenses?";
      if (count === undefined || count === null)
          throw new Error("The parameter 'count' must be defined and cannot be null.");
      else
          url_ += "count=" + encodeURIComponent("" + count) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(data);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUpdateAccountLicenses(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUpdateAccountLicenses(response_);
              } catch (e) {
                  return <Observable<boolean>><any>Observable.throw(e);
              }
          } else
              return <Observable<boolean>><any>Observable.throw(response_);
      });
  }

  protected processUpdateAccountLicenses(response: Response): Observable<boolean> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<boolean>(<any>null);
  }

  getAccountLicenses(accountID: string, deviceModel: string): Observable<LicenseData[]> {
      let url_ = this.baseUrl + "/api/License/GetAccountLicenses?";
      if (accountID === undefined || accountID === null)
          throw new Error("The parameter 'accountID' must be defined and cannot be null.");
      else
          url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
      if (deviceModel !== undefined)
          url_ += "deviceModel=" + encodeURIComponent("" + deviceModel) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetAccountLicenses(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetAccountLicenses(response_);
              } catch (e) {
                  return <Observable<LicenseData[]>><any>Observable.throw(e);
              }
          } else
              return <Observable<LicenseData[]>><any>Observable.throw(response_);
      });
  }

  protected processGetAccountLicenses(response: Response): Observable<LicenseData[]> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
              result200 = [];
              for (let item of resultData200)
                  result200.push(LicenseData.fromJS(item));
          }
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 !== undefined ? resultData400 : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<LicenseData[]>(<any>null);
  }

  removeLicensesFromAccount(deleteLicense: DeviceLicense, count: number): Observable<boolean> {
      let url_ = this.baseUrl + "/api/License/RemoveLicensesFromAccount?";
      if (count === undefined || count === null)
          throw new Error("The parameter 'count' must be defined and cannot be null.");
      else
          url_ += "count=" + encodeURIComponent("" + count) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(deleteLicense);

      let options_ = {
          body: content_,
          method: "delete",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processRemoveLicensesFromAccount(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processRemoveLicensesFromAccount(response_);
              } catch (e) {
                  return <Observable<boolean>><any>Observable.throw(e);
              }
          } else
              return <Observable<boolean>><any>Observable.throw(response_);
      });
  }

  protected processRemoveLicensesFromAccount(response: Response): Observable<boolean> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<boolean>(<any>null);
  }

  getAccountDeviceLicenses(accountID: string, deviceModel: string): Observable<{ [key: string] : LicenseData[]; }> {
      let url_ = this.baseUrl + "/api/License/GetAccountDeviceLicenses?";
      if (accountID === undefined || accountID === null)
          throw new Error("The parameter 'accountID' must be defined and cannot be null.");
      else
          url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
      if (deviceModel !== undefined)
          url_ += "deviceModel=" + encodeURIComponent("" + deviceModel) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "get",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetAccountDeviceLicenses(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetAccountDeviceLicenses(response_);
              } catch (e) {
                  return <Observable<{ [key: string] : LicenseData[]; }>><any>Observable.throw(e);
              }
          } else
              return <Observable<{ [key: string] : LicenseData[]; }>><any>Observable.throw(response_);
      });
  }

  protected processGetAccountDeviceLicenses(response: Response): Observable<{ [key: string] : LicenseData[]; }> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200) {
              result200 = {};
              for (let key in resultData200) {
                  if (resultData200.hasOwnProperty(key))
                      result200[key] = resultData200[key] ? resultData200[key].map((i: any) => LicenseData.fromJS(i)) : [];
              }
          }
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<{ [key: string] : LicenseData[]; }>(<any>null);
  }

  getDeviceLicenses(accountID: string, deviceIds: string[]): Observable<{ [key: string] : LicenseData[]; }> {
      let url_ = this.baseUrl + "/api/License/GetDeviceLicenses?";
      if (accountID === undefined || accountID === null)
          throw new Error("The parameter 'accountID' must be defined and cannot be null.");
      else
          url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(deviceIds);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processGetDeviceLicenses(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processGetDeviceLicenses(response_);
              } catch (e) {
                  return <Observable<{ [key: string] : LicenseData[]; }>><any>Observable.throw(e);
              }
          } else
              return <Observable<{ [key: string] : LicenseData[]; }>><any>Observable.throw(response_);
      });
  }

  protected processGetDeviceLicenses(response: Response): Observable<{ [key: string] : LicenseData[]; }> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200) {
              result200 = {};
              for (let key in resultData200) {
                  if (resultData200.hasOwnProperty(key))
                      result200[key] = resultData200[key] ? resultData200[key].map((i: any) => LicenseData.fromJS(i)) : [];
              }
          }
          return Observable.of(result200);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<{ [key: string] : LicenseData[]; }>(<any>null);
  }

  syncDeviceLicenses(deviceWithLicenses: Device): Observable<string> {
      let url_ = this.baseUrl + "/api/License/SyncDeviceLicenses";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(deviceWithLicenses);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processSyncDeviceLicenses(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processSyncDeviceLicenses(response_);
              } catch (e) {
                  return <Observable<string>><any>Observable.throw(e);
              }
          } else
              return <Observable<string>><any>Observable.throw(response_);
      });
  }

  protected processSyncDeviceLicenses(response: Response): Observable<string> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<string>(<any>null);
  }

  addLicensesToDevices(accountID: string, request: DeviceLicenseRequest): Observable<string> {
      let url_ = this.baseUrl + "/api/License/AddLicensesToDevices?";
      if (accountID === undefined || accountID === null)
          throw new Error("The parameter 'accountID' must be defined and cannot be null.");
      else
          url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(request);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processAddLicensesToDevices(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processAddLicensesToDevices(response_);
              } catch (e) {
                  return <Observable<string>><any>Observable.throw(e);
              }
          } else
              return <Observable<string>><any>Observable.throw(response_);
      });
  }

  protected processAddLicensesToDevices(response: Response): Observable<string> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<string>(<any>null);
  }

  removeLicensesFromDevices(accountID: string, request: DeviceLicenseRequest): Observable<string> {
      let url_ = this.baseUrl + "/api/License/RemoveLicensesFromDevices?";
      if (accountID === undefined || accountID === null)
          throw new Error("The parameter 'accountID' must be defined and cannot be null.");
      else
          url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(request);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processRemoveLicensesFromDevices(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processRemoveLicensesFromDevices(response_);
              } catch (e) {
                  return <Observable<string>><any>Observable.throw(e);
              }
          } else
              return <Observable<string>><any>Observable.throw(response_);
      });
  }

  protected processRemoveLicensesFromDevices(response: Response): Observable<string> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<string>(<any>null);
  }

  updateDeviceLicenses(accountID: string, request: DeviceLicenseRequest): Observable<string> {
      let url_ = this.baseUrl + "/api/License/UpdateDeviceLicenses?";
      if (accountID === undefined || accountID === null)
          throw new Error("The parameter 'accountID' must be defined and cannot be null.");
      else
          url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(request);

      let options_ = {
          body: content_,
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processUpdateDeviceLicenses(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processUpdateDeviceLicenses(response_);
              } catch (e) {
                  return <Observable<string>><any>Observable.throw(e);
              }
          } else
              return <Observable<string>><any>Observable.throw(response_);
      });
  }

  protected processUpdateDeviceLicenses(response: Response): Observable<string> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status === 400) {
          const _responseText = response.text();
          let result400: any = null;
          let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 ? CustomError.fromJS(resultData400) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result400);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<string>(<any>null);
  }

  removeLicensesFromUnClaimedDevice(deviceId: string): Observable<boolean> {
      let url_ = this.baseUrl + "/api/License/RemoveLicensesFromUnClaimedDevice?";
      if (deviceId === undefined)
          throw new Error("The parameter 'deviceId' must be defined.");
      else
          url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = {
          method: "post",
          headers: new Headers({
              "Content-Type": "application/json",
              "Accept": "application/json"
          })
      };

      return this.http.request(url_, options_).flatMap((response_) => {
          return this.processRemoveLicensesFromUnClaimedDevice(response_);
      }).catch((response_: any) => {
          if (response_ instanceof Response) {
              try {
                  return this.processRemoveLicensesFromUnClaimedDevice(response_);
              } catch (e) {
                  return <Observable<boolean>><any>Observable.throw(e);
              }
          } else
              return <Observable<boolean>><any>Observable.throw(response_);
      });
  }

  protected processRemoveLicensesFromUnClaimedDevice(response: Response): Observable<boolean> {
      const status = response.status;

      let _headers: any = response.headers ? response.headers.toJSON() : {};
      if (status === 200) {
          const _responseText = response.text();
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return Observable.of(result200);
      } else if (status === 500) {
          const _responseText = response.text();
          let result500: any = null;
          let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
          return throwException("A server error occurred.", status, _responseText, _headers, result500);
      } else if (status !== 200 && status !== 204) {
          const _responseText = response.text();
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Observable.of<boolean>(<any>null);
  }
}

export class CustomError implements ICustomError {
  severity: SeverityEnum;
  statusCode: HttpStatusCode;
  correlationId?: string;
  message?: string;
  exceptionType?: string;

  constructor(data?: ICustomError) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
          this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
          this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
          this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
          this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
      }
  }

  static fromJS(data: any): CustomError {
      let result = new CustomError();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
      data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
      data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
      data["Message"] = this.message !== undefined ? this.message : <any>null;
      data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
      return data;
  }
}

export interface ICustomError {
  severity: SeverityEnum;
  statusCode: HttpStatusCode;
  correlationId?: string;
  message?: string;
  exceptionType?: string;
}

export enum SeverityEnum {
  None = 0,
  Warning = 1,
  Error = 2,
  Exception = 3,
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultipleChoices = 300,
  Ambiguous = 300,
  MovedPermanently = 301,
  Moved = 301,
  Found = 302,
  Redirect = 302,
  SeeOther = 303,
  RedirectMethod = 303,
  NotModified = 304,
  UseProxy = 305,
  Unused = 306,
  TemporaryRedirect = 307,
  RedirectKeepVerb = 307,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  RequestEntityTooLarge = 413,
  RequestUriTooLong = 414,
  UnsupportedMediaType = 415,
  RequestedRangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  UpgradeRequired = 426,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
}

export class DeviceLicense implements IDeviceLicense {
  id?: string;
  type?: string;
  accountID?: string;
  cid?: string;
  deviceModel?: string;
  status?: LicenseStatus;
  isFromFactory: boolean;
  createdDate?: Date;
  modifiedDate?: Date;
  expirationDate?: Date;
  extendedDate?: Date;
  isExtended?: boolean;
  user?: string;
  purchaseOrder?: string;
  documentType?: string;
  systemKey?: string;
  licenseKey?: string;
  count?: number;
  eTag?: string;

  constructor(data?: IDeviceLicense) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.id = data["id"] !== undefined ? data["id"] : <any>null;
          this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
          this.accountID = data["AccountID"] !== undefined ? data["AccountID"] : <any>null;
          this.cid = data["cid"] !== undefined ? data["cid"] : <any>null;
          this.deviceModel = data["DeviceModel"] !== undefined ? data["DeviceModel"] : <any>null;
          this.status = data["Status"] !== undefined ? data["Status"] : <any>null;
          this.isFromFactory = data["IsFromFactory"] !== undefined ? data["IsFromFactory"] : <any>null;
          this.createdDate = data["CreatedDate"] ? new Date(data["CreatedDate"].toString()) : <any>null;
          this.modifiedDate = data["ModifiedDate"] ? new Date(data["ModifiedDate"].toString()) : <any>null;
          this.expirationDate = data["ExpirationDate"] ? new Date(data["ExpirationDate"].toString()) : <any>null;
          this.extendedDate = data["ExtendedDate"] ? new Date(data["ExtendedDate"].toString()) : <any>null;
          this.isExtended = data["IsExtended"] !== undefined ? data["IsExtended"] : <any>null;
          this.user = data["User"] !== undefined ? data["User"] : <any>null;
          this.purchaseOrder = data["PurchaseOrder"] !== undefined ? data["PurchaseOrder"] : <any>null;
          this.documentType = data["DocumentType"] !== undefined ? data["DocumentType"] : <any>null;
          this.systemKey = data["SystemKey"] !== undefined ? data["SystemKey"] : <any>null;
          this.licenseKey = data["LicenseKey"] !== undefined ? data["LicenseKey"] : <any>null;
          this.count = data["Count"] !== undefined ? data["Count"] : <any>null;
          this.eTag = data["ETag"] !== undefined ? data["ETag"] : <any>null;
      }
  }

  static fromJS(data: any): DeviceLicense {
      let result = new DeviceLicense();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["Type"] = this.type !== undefined ? this.type : <any>null;
      data["AccountID"] = this.accountID !== undefined ? this.accountID : <any>null;
      data["cid"] = this.cid !== undefined ? this.cid : <any>null;
      data["DeviceModel"] = this.deviceModel !== undefined ? this.deviceModel : <any>null;
      data["Status"] = this.status !== undefined ? this.status : <any>null;
      data["IsFromFactory"] = this.isFromFactory !== undefined ? this.isFromFactory : <any>null;
      data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
      data["ModifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>null;
      data["ExpirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
      data["ExtendedDate"] = this.extendedDate ? this.extendedDate.toISOString() : <any>null;
      data["IsExtended"] = this.isExtended !== undefined ? this.isExtended : <any>null;
      data["User"] = this.user !== undefined ? this.user : <any>null;
      data["PurchaseOrder"] = this.purchaseOrder !== undefined ? this.purchaseOrder : <any>null;
      data["DocumentType"] = this.documentType !== undefined ? this.documentType : <any>null;
      data["SystemKey"] = this.systemKey !== undefined ? this.systemKey : <any>null;
      data["LicenseKey"] = this.licenseKey !== undefined ? this.licenseKey : <any>null;
      data["Count"] = this.count !== undefined ? this.count : <any>null;
      data["ETag"] = this.eTag !== undefined ? this.eTag : <any>null;
      return data;
  }
}

export interface IDeviceLicense {
  id?: string;
  type?: string;
  accountID?: string;
  cid?: string;
  deviceModel?: string;
  status?: LicenseStatus;
  isFromFactory: boolean;
  createdDate?: Date;
  modifiedDate?: Date;
  expirationDate?: Date;
  extendedDate?: Date;
  isExtended?: boolean;
  user?: string;
  purchaseOrder?: string;
  documentType?: string;
  systemKey?: string;
  licenseKey?: string;
  count?: number;
  eTag?: string;
}

export enum LicenseStatus {
  Added = <any>"Added",
  PendingAdd = <any>"PendingAdd",
  Deleted = <any>"Deleted",
  PendingDelete = <any>"PendingDelete",
  Available = <any>"Available",
  Unclaimed = <any>"Unclaimed",
  DeleteOnDevice = <any>"DeleteOnDevice",
}

export class LicenseData implements ILicenseData {
  accountID?: string;
  deviceID?: string;
  type?: string;
  deviceModel?: string;
  count?: number;
  maxCount: number;
  inUseCount: number;
  expirationDate?: Date;
  extendedDate?: Date;

  constructor(data?: ILicenseData) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.accountID = data["AccountID"] !== undefined ? data["AccountID"] : <any>null;
          this.deviceID = data["DeviceID"] !== undefined ? data["DeviceID"] : <any>null;
          this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
          this.deviceModel = data["DeviceModel"] !== undefined ? data["DeviceModel"] : <any>null;
          this.count = data["Count"] !== undefined ? data["Count"] : <any>null;
          this.maxCount = data["MaxCount"] !== undefined ? data["MaxCount"] : <any>null;
          this.inUseCount = data["InUseCount"] !== undefined ? data["InUseCount"] : <any>null;
          this.expirationDate = data["ExpirationDate"] ? new Date(data["ExpirationDate"].toString()) : <any>null;
          this.extendedDate = data["ExtendedDate"] ? new Date(data["ExtendedDate"].toString()) : <any>null;
      }
  }

  static fromJS(data: any): LicenseData {
      let result = new LicenseData();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["AccountID"] = this.accountID !== undefined ? this.accountID : <any>null;
      data["DeviceID"] = this.deviceID !== undefined ? this.deviceID : <any>null;
      data["Type"] = this.type !== undefined ? this.type : <any>null;
      data["DeviceModel"] = this.deviceModel !== undefined ? this.deviceModel : <any>null;
      data["Count"] = this.count !== undefined ? this.count : <any>null;
      data["MaxCount"] = this.maxCount !== undefined ? this.maxCount : <any>null;
      data["InUseCount"] = this.inUseCount !== undefined ? this.inUseCount : <any>null;
      data["ExpirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
      data["ExtendedDate"] = this.extendedDate ? this.extendedDate.toISOString() : <any>null;
      return data;
  }
}

export interface ILicenseData {
  accountID?: string;
  deviceID?: string;
  type?: string;
  deviceModel?: string;
  count?: number;
  maxCount: number;
  inUseCount: number;
  expirationDate?: Date;
  extendedDate?: Date;
}

export class ObjectVersion implements IObjectVersion {
  version?: string;

  constructor(data?: IObjectVersion) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
      }
  }

  static fromJS(data: any): ObjectVersion {
      let result = new ObjectVersion();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Version"] = this.version !== undefined ? this.version : <any>null;
      return data;
  }
}

export interface IObjectVersion {
  version?: string;
}

export class DevicePropertyDocument extends ObjectVersion implements IDevicePropertyDocument {
  id?: string;
  cid?: string;
  propertyType?: string;
  eTag?: string;

  constructor(data?: IDevicePropertyDocument) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.id = data["id"] !== undefined ? data["id"] : <any>null;
          this.cid = data["cid"] !== undefined ? data["cid"] : <any>null;
          this.propertyType = data["PropertyType"] !== undefined ? data["PropertyType"] : <any>null;
          this.eTag = data["ETag"] !== undefined ? data["ETag"] : <any>null;
      }
  }

  static fromJS(data: any): DevicePropertyDocument {
      let result = new DevicePropertyDocument();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["cid"] = this.cid !== undefined ? this.cid : <any>null;
      data["PropertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
      data["ETag"] = this.eTag !== undefined ? this.eTag : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IDevicePropertyDocument extends IObjectVersion {
  id?: string;
  cid?: string;
  propertyType?: string;
  eTag?: string;
}

export class DeviceList extends DevicePropertyDocument implements IDeviceList {
  documentType?: string;
  userDeviceName?: string;
  region?: string;
  connectedToIoTHub?: boolean;
  deviceInfo?: DeviceInfo;
  accountId?: string;
  groupId?: string;
  licenseIds?: string[];
  userPrincipalNames?: string[];
  tagIds?: string[];
  action?: MergeAction;
  ethernet?: Ethernet;
  created?: Date;
  lastModified?: Date;
  lastCommunicated?: Date;
  fCSPUFVersion?: string;
  scheduledActionsResult?: ScheduledActionsResult;

  constructor(data?: IDeviceList) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.documentType = data["DocumentType"] !== undefined ? data["DocumentType"] : <any>null;
          this.userDeviceName = data["UserDeviceName"] !== undefined ? data["UserDeviceName"] : <any>null;
          this.region = data["Region"] !== undefined ? data["Region"] : <any>null;
          this.connectedToIoTHub = data["ConnectedToIoTHub"] !== undefined ? data["ConnectedToIoTHub"] : <any>null;
          this.deviceInfo = data["DeviceInfo"] ? DeviceInfo.fromJS(data["DeviceInfo"]) : <any>null;
          this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
          this.groupId = data["GroupId"] !== undefined ? data["GroupId"] : <any>null;
          if (data["LicenseIds"] && data["LicenseIds"].constructor === Array) {
              this.licenseIds = [];
              for (let item of data["LicenseIds"])
                  this.licenseIds.push(item);
          }
          if (data["UserPrincipalNames"] && data["UserPrincipalNames"].constructor === Array) {
              this.userPrincipalNames = [];
              for (let item of data["UserPrincipalNames"])
                  this.userPrincipalNames.push(item);
          }
          if (data["TagIds"] && data["TagIds"].constructor === Array) {
              this.tagIds = [];
              for (let item of data["TagIds"])
                  this.tagIds.push(item);
          }
          this.action = data["Action"] ? MergeAction.fromJS(data["Action"]) : <any>null;
          this.ethernet = data["Ethernet"] ? Ethernet.fromJS(data["Ethernet"]) : <any>null;
          this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
          this.lastModified = data["LastModified"] ? new Date(data["LastModified"].toString()) : <any>null;
          this.lastCommunicated = data["LastCommunicated"] ? new Date(data["LastCommunicated"].toString()) : <any>null;
          this.fCSPUFVersion = data["FCSPUFVersion"] !== undefined ? data["FCSPUFVersion"] : <any>null;
          this.scheduledActionsResult = data["ScheduledActionsResult"] ? ScheduledActionsResult.fromJS(data["ScheduledActionsResult"]) : <any>null;
      }
  }

  static fromJS(data: any): DeviceList {
      let result = new DeviceList();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DocumentType"] = this.documentType !== undefined ? this.documentType : <any>null;
      data["UserDeviceName"] = this.userDeviceName !== undefined ? this.userDeviceName : <any>null;
      data["Region"] = this.region !== undefined ? this.region : <any>null;
      data["ConnectedToIoTHub"] = this.connectedToIoTHub !== undefined ? this.connectedToIoTHub : <any>null;
      data["DeviceInfo"] = this.deviceInfo ? this.deviceInfo.toJSON() : <any>null;
      data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
      data["GroupId"] = this.groupId !== undefined ? this.groupId : <any>null;
      if (this.licenseIds && this.licenseIds.constructor === Array) {
          data["LicenseIds"] = [];
          for (let item of this.licenseIds)
              data["LicenseIds"].push(item);
      }
      if (this.userPrincipalNames && this.userPrincipalNames.constructor === Array) {
          data["UserPrincipalNames"] = [];
          for (let item of this.userPrincipalNames)
              data["UserPrincipalNames"].push(item);
      }
      if (this.tagIds && this.tagIds.constructor === Array) {
          data["TagIds"] = [];
          for (let item of this.tagIds)
              data["TagIds"].push(item);
      }
      data["Action"] = this.action ? this.action.toJSON() : <any>null;
      data["Ethernet"] = this.ethernet ? this.ethernet.toJSON() : <any>null;
      data["Created"] = this.created ? this.created.toISOString() : <any>null;
      data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
      data["LastCommunicated"] = this.lastCommunicated ? this.lastCommunicated.toISOString() : <any>null;
      data["FCSPUFVersion"] = this.fCSPUFVersion !== undefined ? this.fCSPUFVersion : <any>null;
      data["ScheduledActionsResult"] = this.scheduledActionsResult ? this.scheduledActionsResult.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IDeviceList extends IDevicePropertyDocument {
  documentType?: string;
  userDeviceName?: string;
  region?: string;
  connectedToIoTHub?: boolean;
  deviceInfo?: DeviceInfo;
  accountId?: string;
  groupId?: string;
  licenseIds?: string[];
  userPrincipalNames?: string[];
  tagIds?: string[];
  action?: MergeAction;
  ethernet?: Ethernet;
  created?: Date;
  lastModified?: Date;
  lastCommunicated?: Date;
  fCSPUFVersion?: string;
  scheduledActionsResult?: ScheduledActionsResult;
}

export class Device extends DeviceList implements IDevice {
  licenseRegistry?: LicenseRegistry;
  autoUpdateMaster?: AutoUpdateMaster;
  fusionCloud?: FusionCloud;
  sip?: FWSIP;
  systemClock?: SystemClock;
  systemVersions?: SystemVersions;
  airMedia?: AirMedia;
  audioVideoInputOutput?: AudioVideoInputOutput;
  app?: App;
  thirdPartyApplications?: ThirdPartyApplications;
  cloudSettings?: CloudSettings;
  display?: Display;

  constructor(data?: IDevice) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.licenseRegistry = data["LicenseRegistry"] ? LicenseRegistry.fromJS(data["LicenseRegistry"]) : <any>null;
          this.autoUpdateMaster = data["AutoUpdateMaster"] ? AutoUpdateMaster.fromJS(data["AutoUpdateMaster"]) : <any>null;
          this.fusionCloud = data["FusionCloud"] ? FusionCloud.fromJS(data["FusionCloud"]) : <any>null;
          this.sip = data["Sip"] ? FWSIP.fromJS(data["Sip"]) : <any>null;
          this.systemClock = data["SystemClock"] ? SystemClock.fromJS(data["SystemClock"]) : <any>null;
          this.systemVersions = data["SystemVersions"] ? SystemVersions.fromJS(data["SystemVersions"]) : <any>null;
          this.airMedia = data["AirMedia"] ? AirMedia.fromJS(data["AirMedia"]) : <any>null;
          this.audioVideoInputOutput = data["AudioVideoInputOutput"] ? AudioVideoInputOutput.fromJS(data["AudioVideoInputOutput"]) : <any>null;
          this.app = data["App"] ? App.fromJS(data["App"]) : <any>null;
          this.thirdPartyApplications = data["ThirdPartyApplications"] ? ThirdPartyApplications.fromJS(data["ThirdPartyApplications"]) : <any>null;
          this.cloudSettings = data["CloudSettings"] ? CloudSettings.fromJS(data["CloudSettings"]) : <any>null;
          this.display = data["Display"] ? Display.fromJS(data["Display"]) : <any>null;
      }
  }

  static fromJS(data: any): Device {
      let result = new Device();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["LicenseRegistry"] = this.licenseRegistry ? this.licenseRegistry.toJSON() : <any>null;
      data["AutoUpdateMaster"] = this.autoUpdateMaster ? this.autoUpdateMaster.toJSON() : <any>null;
      data["FusionCloud"] = this.fusionCloud ? this.fusionCloud.toJSON() : <any>null;
      data["Sip"] = this.sip ? this.sip.toJSON() : <any>null;
      data["SystemClock"] = this.systemClock ? this.systemClock.toJSON() : <any>null;
      data["SystemVersions"] = this.systemVersions ? this.systemVersions.toJSON() : <any>null;
      data["AirMedia"] = this.airMedia ? this.airMedia.toJSON() : <any>null;
      data["AudioVideoInputOutput"] = this.audioVideoInputOutput ? this.audioVideoInputOutput.toJSON() : <any>null;
      data["App"] = this.app ? this.app.toJSON() : <any>null;
      data["ThirdPartyApplications"] = this.thirdPartyApplications ? this.thirdPartyApplications.toJSON() : <any>null;
      data["CloudSettings"] = this.cloudSettings ? this.cloudSettings.toJSON() : <any>null;
      data["Display"] = this.display ? this.display.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IDevice extends IDeviceList {
  licenseRegistry?: LicenseRegistry;
  autoUpdateMaster?: AutoUpdateMaster;
  fusionCloud?: FusionCloud;
  sip?: FWSIP;
  systemClock?: SystemClock;
  systemVersions?: SystemVersions;
  airMedia?: AirMedia;
  audioVideoInputOutput?: AudioVideoInputOutput;
  app?: App;
  thirdPartyApplications?: ThirdPartyApplications;
  cloudSettings?: CloudSettings;
  display?: Display;
}

export class LicenseRegistry extends DevicePropertyDocument implements ILicenseRegistry {
  licenses?: License[];
  systemKey?: string;

  constructor(data?: ILicenseRegistry) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          if (data["Licenses"] && data["Licenses"].constructor === Array) {
              this.licenses = [];
              for (let item of data["Licenses"])
                  this.licenses.push(License.fromJS(item));
          }
          this.systemKey = data["SystemKey"] !== undefined ? data["SystemKey"] : <any>null;
      }
  }

  static fromJS(data: any): LicenseRegistry {
      let result = new LicenseRegistry();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.licenses && this.licenses.constructor === Array) {
          data["Licenses"] = [];
          for (let item of this.licenses)
              data["Licenses"].push(item.toJSON());
      }
      data["SystemKey"] = this.systemKey !== undefined ? this.systemKey : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ILicenseRegistry extends IDevicePropertyDocument {
  licenses?: License[];
  systemKey?: string;
}

export class License implements ILicense {
  name?: string;
  vendorId?: number;
  moduleId?: number;
  info?: string;
  expiration?: number;
  key?: string;
  count?: number;
  status?: Status;

  constructor(data?: ILicense) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.vendorId = data["VendorId"] !== undefined ? data["VendorId"] : <any>null;
          this.moduleId = data["ModuleId"] !== undefined ? data["ModuleId"] : <any>null;
          this.info = data["Info"] !== undefined ? data["Info"] : <any>null;
          this.expiration = data["Expiration"] !== undefined ? data["Expiration"] : <any>null;
          this.key = data["Key"] !== undefined ? data["Key"] : <any>null;
          this.count = data["Count"] !== undefined ? data["Count"] : <any>null;
          this.status = data["Status"] !== undefined ? data["Status"] : <any>null;
      }
  }

  static fromJS(data: any): License {
      let result = new License();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["VendorId"] = this.vendorId !== undefined ? this.vendorId : <any>null;
      data["ModuleId"] = this.moduleId !== undefined ? this.moduleId : <any>null;
      data["Info"] = this.info !== undefined ? this.info : <any>null;
      data["Expiration"] = this.expiration !== undefined ? this.expiration : <any>null;
      data["Key"] = this.key !== undefined ? this.key : <any>null;
      data["Count"] = this.count !== undefined ? this.count : <any>null;
      data["Status"] = this.status !== undefined ? this.status : <any>null;
      return data;
  }
}

export interface ILicense {
  name?: string;
  vendorId?: number;
  moduleId?: number;
  info?: string;
  expiration?: number;
  key?: string;
  count?: number;
  status?: Status;
}

export enum Status {
  Applied = <any>"Applied",
  Invalid = <any>"Invalid",
}

export class AutoUpdateMaster extends DevicePropertyDocument implements IAutoUpdateMaster {
  isEnabled?: boolean;
  forceCheckNow?: boolean;
  manifestPath?: string;
  pluginCatalogPath?: string;
  pUFVersion?: string;
  serverCredentials?: Credentials;
  deviceCredentials?: Credentials;
  autoUpdateStatus?: AutoUpdateStatus;
  autoUpdateSchedule?: AutoUpdateSchedule;

  constructor(data?: IAutoUpdateMaster) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.forceCheckNow = data["ForceCheckNow"] !== undefined ? data["ForceCheckNow"] : <any>null;
          this.manifestPath = data["ManifestPath"] !== undefined ? data["ManifestPath"] : <any>null;
          this.pluginCatalogPath = data["PluginCatalogPath"] !== undefined ? data["PluginCatalogPath"] : <any>null;
          this.pUFVersion = data["PUFVersion"] !== undefined ? data["PUFVersion"] : <any>null;
          this.serverCredentials = data["ServerCredentials"] ? Credentials.fromJS(data["ServerCredentials"]) : <any>null;
          this.deviceCredentials = data["DeviceCredentials"] ? Credentials.fromJS(data["DeviceCredentials"]) : <any>null;
          this.autoUpdateStatus = data["AutoUpdateStatus"] ? AutoUpdateStatus.fromJS(data["AutoUpdateStatus"]) : <any>null;
          this.autoUpdateSchedule = data["AutoUpdateSchedule"] ? AutoUpdateSchedule.fromJS(data["AutoUpdateSchedule"]) : <any>null;
      }
  }

  static fromJS(data: any): AutoUpdateMaster {
      let result = new AutoUpdateMaster();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["ForceCheckNow"] = this.forceCheckNow !== undefined ? this.forceCheckNow : <any>null;
      data["ManifestPath"] = this.manifestPath !== undefined ? this.manifestPath : <any>null;
      data["PluginCatalogPath"] = this.pluginCatalogPath !== undefined ? this.pluginCatalogPath : <any>null;
      data["PUFVersion"] = this.pUFVersion !== undefined ? this.pUFVersion : <any>null;
      data["ServerCredentials"] = this.serverCredentials ? this.serverCredentials.toJSON() : <any>null;
      data["DeviceCredentials"] = this.deviceCredentials ? this.deviceCredentials.toJSON() : <any>null;
      data["AutoUpdateStatus"] = this.autoUpdateStatus ? this.autoUpdateStatus.toJSON() : <any>null;
      data["AutoUpdateSchedule"] = this.autoUpdateSchedule ? this.autoUpdateSchedule.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IAutoUpdateMaster extends IDevicePropertyDocument {
  isEnabled?: boolean;
  forceCheckNow?: boolean;
  manifestPath?: string;
  pluginCatalogPath?: string;
  pUFVersion?: string;
  serverCredentials?: Credentials;
  deviceCredentials?: Credentials;
  autoUpdateStatus?: AutoUpdateStatus;
  autoUpdateSchedule?: AutoUpdateSchedule;
}

export class Credentials implements ICredentials {
  userName?: string;
  password?: string;

  constructor(data?: ICredentials) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
          this.password = data["Password"] !== undefined ? data["Password"] : <any>null;
      }
  }

  static fromJS(data: any): Credentials {
      let result = new Credentials();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
      data["Password"] = this.password !== undefined ? this.password : <any>null;
      return data;
  }
}

export interface ICredentials {
  userName?: string;
  password?: string;
}

export class AutoUpdateStatus implements IAutoUpdateStatus {
  autoUpdateState?: string;
  lastManifestDownload?: Date;
  lastManifestCheck?: Date;
  manifestCheckStatus?: string;
  lastError?: string;
  completedDevices?: number;
  upToDateDevices?: number;
  devicesWithFailedTransfers?: number;

  constructor(data?: IAutoUpdateStatus) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.autoUpdateState = data["AutoUpdateState"] !== undefined ? data["AutoUpdateState"] : <any>null;
          this.lastManifestDownload = data["LastManifestDownload"] ? new Date(data["LastManifestDownload"].toString()) : <any>null;
          this.lastManifestCheck = data["LastManifestCheck"] ? new Date(data["LastManifestCheck"].toString()) : <any>null;
          this.manifestCheckStatus = data["ManifestCheckStatus"] !== undefined ? data["ManifestCheckStatus"] : <any>null;
          this.lastError = data["LastError"] !== undefined ? data["LastError"] : <any>null;
          this.completedDevices = data["CompletedDevices"] !== undefined ? data["CompletedDevices"] : <any>null;
          this.upToDateDevices = data["UpToDateDevices"] !== undefined ? data["UpToDateDevices"] : <any>null;
          this.devicesWithFailedTransfers = data["DevicesWithFailedTransfers"] !== undefined ? data["DevicesWithFailedTransfers"] : <any>null;
      }
  }

  static fromJS(data: any): AutoUpdateStatus {
      let result = new AutoUpdateStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["AutoUpdateState"] = this.autoUpdateState !== undefined ? this.autoUpdateState : <any>null;
      data["LastManifestDownload"] = this.lastManifestDownload ? this.lastManifestDownload.toISOString() : <any>null;
      data["LastManifestCheck"] = this.lastManifestCheck ? this.lastManifestCheck.toISOString() : <any>null;
      data["ManifestCheckStatus"] = this.manifestCheckStatus !== undefined ? this.manifestCheckStatus : <any>null;
      data["LastError"] = this.lastError !== undefined ? this.lastError : <any>null;
      data["CompletedDevices"] = this.completedDevices !== undefined ? this.completedDevices : <any>null;
      data["UpToDateDevices"] = this.upToDateDevices !== undefined ? this.upToDateDevices : <any>null;
      data["DevicesWithFailedTransfers"] = this.devicesWithFailedTransfers !== undefined ? this.devicesWithFailedTransfers : <any>null;
      return data;
  }
}

export interface IAutoUpdateStatus {
  autoUpdateState?: string;
  lastManifestDownload?: Date;
  lastManifestCheck?: Date;
  manifestCheckStatus?: string;
  lastError?: string;
  completedDevices?: number;
  upToDateDevices?: number;
  devicesWithFailedTransfers?: number;
}

export class AutoUpdateSchedule implements IAutoUpdateSchedule {
  dayOfWeek?: string;
  timeOfDay?: string;
  checkInterval?: number;

  constructor(data?: IAutoUpdateSchedule) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.dayOfWeek = data["DayOfWeek"] !== undefined ? data["DayOfWeek"] : <any>null;
          this.timeOfDay = data["TimeOfDay"] !== undefined ? data["TimeOfDay"] : <any>null;
          this.checkInterval = data["CheckInterval"] !== undefined ? data["CheckInterval"] : <any>null;
      }
  }

  static fromJS(data: any): AutoUpdateSchedule {
      let result = new AutoUpdateSchedule();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DayOfWeek"] = this.dayOfWeek !== undefined ? this.dayOfWeek : <any>null;
      data["TimeOfDay"] = this.timeOfDay !== undefined ? this.timeOfDay : <any>null;
      data["CheckInterval"] = this.checkInterval !== undefined ? this.checkInterval : <any>null;
      return data;
  }
}

export interface IAutoUpdateSchedule {
  dayOfWeek?: string;
  timeOfDay?: string;
  checkInterval?: number;
}

export class FusionCloud extends DevicePropertyDocument implements IFusionCloud {
  isEnabled?: boolean;
  url?: string;

  constructor(data?: IFusionCloud) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.url = data["Url"] !== undefined ? data["Url"] : <any>null;
      }
  }

  static fromJS(data: any): FusionCloud {
      let result = new FusionCloud();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["Url"] = this.url !== undefined ? this.url : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IFusionCloud extends IDevicePropertyDocument {
  isEnabled?: boolean;
  url?: string;
}

export class FWSIP_2_0_0 extends DevicePropertyDocument implements IFWSIP_2_0_0 {
  isEnabled?: boolean;
  port?: number;
  proxyServer?: string;
  serverUsername?: string;
  sipServerStatus?: boolean;
  serverName?: string;
  nameServer?: string;
  transportType?: string;
  ethernetAdaptersToUse?: string[];
  localExt?: string;
  serverIpAddress?: string;
  serverPassword?: string;
  serverRealm?: string;

  constructor(data?: IFWSIP_2_0_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.port = data["Port"] !== undefined ? data["Port"] : <any>null;
          this.proxyServer = data["ProxyServer"] !== undefined ? data["ProxyServer"] : <any>null;
          this.serverUsername = data["ServerUsername"] !== undefined ? data["ServerUsername"] : <any>null;
          this.sipServerStatus = data["SipServerStatus"] !== undefined ? data["SipServerStatus"] : <any>null;
          this.serverName = data["ServerName"] !== undefined ? data["ServerName"] : <any>null;
          this.nameServer = data["NameServer"] !== undefined ? data["NameServer"] : <any>null;
          this.transportType = data["TransportType"] !== undefined ? data["TransportType"] : <any>null;
          if (data["EthernetAdaptersToUse"] && data["EthernetAdaptersToUse"].constructor === Array) {
              this.ethernetAdaptersToUse = [];
              for (let item of data["EthernetAdaptersToUse"])
                  this.ethernetAdaptersToUse.push(item);
          }
          this.localExt = data["LocalExt"] !== undefined ? data["LocalExt"] : <any>null;
          this.serverIpAddress = data["ServerIpAddress"] !== undefined ? data["ServerIpAddress"] : <any>null;
          this.serverPassword = data["ServerPassword"] !== undefined ? data["ServerPassword"] : <any>null;
          this.serverRealm = data["ServerRealm"] !== undefined ? data["ServerRealm"] : <any>null;
      }
  }

  static fromJS(data: any): FWSIP_2_0_0 {
      let result = new FWSIP_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["Port"] = this.port !== undefined ? this.port : <any>null;
      data["ProxyServer"] = this.proxyServer !== undefined ? this.proxyServer : <any>null;
      data["ServerUsername"] = this.serverUsername !== undefined ? this.serverUsername : <any>null;
      data["SipServerStatus"] = this.sipServerStatus !== undefined ? this.sipServerStatus : <any>null;
      data["ServerName"] = this.serverName !== undefined ? this.serverName : <any>null;
      data["NameServer"] = this.nameServer !== undefined ? this.nameServer : <any>null;
      data["TransportType"] = this.transportType !== undefined ? this.transportType : <any>null;
      if (this.ethernetAdaptersToUse && this.ethernetAdaptersToUse.constructor === Array) {
          data["EthernetAdaptersToUse"] = [];
          for (let item of this.ethernetAdaptersToUse)
              data["EthernetAdaptersToUse"].push(item);
      }
      data["LocalExt"] = this.localExt !== undefined ? this.localExt : <any>null;
      data["ServerIpAddress"] = this.serverIpAddress !== undefined ? this.serverIpAddress : <any>null;
      data["ServerPassword"] = this.serverPassword !== undefined ? this.serverPassword : <any>null;
      data["ServerRealm"] = this.serverRealm !== undefined ? this.serverRealm : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IFWSIP_2_0_0 extends IDevicePropertyDocument {
  isEnabled?: boolean;
  port?: number;
  proxyServer?: string;
  serverUsername?: string;
  sipServerStatus?: boolean;
  serverName?: string;
  nameServer?: string;
  transportType?: string;
  ethernetAdaptersToUse?: string[];
  localExt?: string;
  serverIpAddress?: string;
  serverPassword?: string;
  serverRealm?: string;
}

export class FWSIP extends FWSIP_2_0_0 implements IFWSIP {
  displayExtension?: string;

  constructor(data?: IFWSIP) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.displayExtension = data["DisplayExtension"] !== undefined ? data["DisplayExtension"] : <any>null;
      }
  }

  static fromJS(data: any): FWSIP {
      let result = new FWSIP();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DisplayExtension"] = this.displayExtension !== undefined ? this.displayExtension : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IFWSIP extends IFWSIP_2_0_0 {
  displayExtension?: string;
}

export class SystemClock extends DevicePropertyDocument implements ISystemClock {
  daylightSavingsEnabled?: boolean;
  timeZone?: string;
  sntp?: Sntp;

  constructor(data?: ISystemClock) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.daylightSavingsEnabled = data["DaylightSavingsEnabled"] !== undefined ? data["DaylightSavingsEnabled"] : <any>null;
          this.timeZone = data["TimeZone"] !== undefined ? data["TimeZone"] : <any>null;
          this.sntp = data["Sntp"] ? Sntp.fromJS(data["Sntp"]) : <any>null;
      }
  }

  static fromJS(data: any): SystemClock {
      let result = new SystemClock();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DaylightSavingsEnabled"] = this.daylightSavingsEnabled !== undefined ? this.daylightSavingsEnabled : <any>null;
      data["TimeZone"] = this.timeZone !== undefined ? this.timeZone : <any>null;
      data["Sntp"] = this.sntp ? this.sntp.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ISystemClock extends IDevicePropertyDocument {
  daylightSavingsEnabled?: boolean;
  timeZone?: string;
  sntp?: Sntp;
}

export class Sntp implements ISntp {
  isEnabled?: boolean;
  sntpServer?: string;

  constructor(data?: ISntp) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.sntpServer = data["SntpServer"] !== undefined ? data["SntpServer"] : <any>null;
      }
  }

  static fromJS(data: any): Sntp {
      let result = new Sntp();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["SntpServer"] = this.sntpServer !== undefined ? this.sntpServer : <any>null;
      return data;
  }
}

export interface ISntp {
  isEnabled?: boolean;
  sntpServer?: string;
}

export class SystemVersions extends DevicePropertyDocument implements ISystemVersions {
  components?: Component[];
  lastInstalledPufVersion?: string;

  constructor(data?: ISystemVersions) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          if (data["Components"] && data["Components"].constructor === Array) {
              this.components = [];
              for (let item of data["Components"])
                  this.components.push(Component.fromJS(item));
          }
          this.lastInstalledPufVersion = data["LastInstalledPufVersion"] !== undefined ? data["LastInstalledPufVersion"] : <any>null;
      }
  }

  static fromJS(data: any): SystemVersions {
      let result = new SystemVersions();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.components && this.components.constructor === Array) {
          data["Components"] = [];
          for (let item of this.components)
              data["Components"].push(item.toJSON());
      }
      data["LastInstalledPufVersion"] = this.lastInstalledPufVersion !== undefined ? this.lastInstalledPufVersion : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ISystemVersions extends IDevicePropertyDocument {
  components?: Component[];
  lastInstalledPufVersion?: string;
}

export class Component implements IComponent {
  name?: string;
  version?: string;
  buildTime?: Date;
  category?: string;
  subComponents?: Component[];

  constructor(data?: IComponent) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
          this.buildTime = data["BuildTime"] ? new Date(data["BuildTime"].toString()) : <any>null;
          this.category = data["Category"] !== undefined ? data["Category"] : <any>null;
          if (data["SubComponents"] && data["SubComponents"].constructor === Array) {
              this.subComponents = [];
              for (let item of data["SubComponents"])
                  this.subComponents.push(Component.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Component {
      let result = new Component();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Version"] = this.version !== undefined ? this.version : <any>null;
      data["BuildTime"] = this.buildTime ? this.buildTime.toISOString() : <any>null;
      data["Category"] = this.category !== undefined ? this.category : <any>null;
      if (this.subComponents && this.subComponents.constructor === Array) {
          data["SubComponents"] = [];
          for (let item of this.subComponents)
              data["SubComponents"].push(item.toJSON());
      }
      return data;
  }
}

export interface IComponent {
  name?: string;
  version?: string;
  buildTime?: Date;
  category?: string;
  subComponents?: Component[];
}

export class AirMedia_2_0_0 extends DevicePropertyDocument implements IAirMedia_2_0_0 {
  loginCodeMode?: string;
  loginCode?: string;
  ethernetAdaptersToUse?: string[];

  constructor(data?: IAirMedia_2_0_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.loginCodeMode = data["LoginCodeMode"] !== undefined ? data["LoginCodeMode"] : <any>null;
          this.loginCode = data["LoginCode"] !== undefined ? data["LoginCode"] : <any>null;
          if (data["EthernetAdaptersToUse"] && data["EthernetAdaptersToUse"].constructor === Array) {
              this.ethernetAdaptersToUse = [];
              for (let item of data["EthernetAdaptersToUse"])
                  this.ethernetAdaptersToUse.push(item);
          }
      }
  }

  static fromJS(data: any): AirMedia_2_0_0 {
      let result = new AirMedia_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["LoginCodeMode"] = this.loginCodeMode !== undefined ? this.loginCodeMode : <any>null;
      data["LoginCode"] = this.loginCode !== undefined ? this.loginCode : <any>null;
      if (this.ethernetAdaptersToUse && this.ethernetAdaptersToUse.constructor === Array) {
          data["EthernetAdaptersToUse"] = [];
          for (let item of this.ethernetAdaptersToUse)
              data["EthernetAdaptersToUse"].push(item);
      }
      super.toJSON(data);
      return data;
  }
}

export interface IAirMedia_2_0_0 extends IDevicePropertyDocument {
  loginCodeMode?: string;
  loginCode?: string;
  ethernetAdaptersToUse?: string[];
}

export class AirMedia_2_0_1 extends AirMedia_2_0_0 implements IAirMedia_2_0_1 {
  connectionDisplayOptions?: ConnectionDisplayOptionsOld;

  constructor(data?: IAirMedia_2_0_1) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.connectionDisplayOptions = data["ConnectionDisplayOptions"] ? ConnectionDisplayOptionsOld.fromJS(data["ConnectionDisplayOptions"]) : <any>null;
      }
  }

  static fromJS(data: any): AirMedia_2_0_1 {
      let result = new AirMedia_2_0_1();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["ConnectionDisplayOptions"] = this.connectionDisplayOptions ? this.connectionDisplayOptions.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IAirMedia_2_0_1 extends IAirMedia_2_0_0 {
  connectionDisplayOptions?: ConnectionDisplayOptionsOld;
}

export class AirMedia extends AirMedia_2_0_1 implements IAirMedia {
  isEnabled?: boolean;
  showLoginCode?: boolean;
  connectionDisplayOptions?: ConnectionDisplayOptions;

  constructor(data?: IAirMedia) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.showLoginCode = data["ShowLoginCode"] !== undefined ? data["ShowLoginCode"] : <any>null;
          this.connectionDisplayOptions = data["ConnectionDisplayOptions"] ? ConnectionDisplayOptions.fromJS(data["ConnectionDisplayOptions"]) : <any>null;
      }
  }

  static fromJS(data: any): AirMedia {
      let result = new AirMedia();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["ShowLoginCode"] = this.showLoginCode !== undefined ? this.showLoginCode : <any>null;
      data["ConnectionDisplayOptions"] = this.connectionDisplayOptions ? this.connectionDisplayOptions.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IAirMedia extends IAirMedia_2_0_1 {
  isEnabled?: boolean;
  showLoginCode?: boolean;
  connectionDisplayOptions?: ConnectionDisplayOptions;
}

export class ConnectionDisplayOptions implements IConnectionDisplayOptions {
  connectionInfoMode?: ConnectionInfoMode;
  showConnectionInfo?: boolean;
  customString?: string;

  constructor(data?: IConnectionDisplayOptions) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.connectionInfoMode = data["ConnectionInfoMode"] !== undefined ? data["ConnectionInfoMode"] : <any>null;
          this.showConnectionInfo = data["ShowConnectionInfo"] !== undefined ? data["ShowConnectionInfo"] : <any>null;
          this.customString = data["CustomString"] !== undefined ? data["CustomString"] : <any>null;
      }
  }

  static fromJS(data: any): ConnectionDisplayOptions {
      let result = new ConnectionDisplayOptions();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["ConnectionInfoMode"] = this.connectionInfoMode !== undefined ? this.connectionInfoMode : <any>null;
      data["ShowConnectionInfo"] = this.showConnectionInfo !== undefined ? this.showConnectionInfo : <any>null;
      data["CustomString"] = this.customString !== undefined ? this.customString : <any>null;
      return data;
  }
}

export interface IConnectionDisplayOptions {
  connectionInfoMode?: ConnectionInfoMode;
  showConnectionInfo?: boolean;
  customString?: string;
}

export enum ConnectionInfoMode {
  IPAddress = <any>"IPAddress",
  Host = <any>"Host",
  HostAndDomain = <any>"HostAndDomain",
  Custom = <any>"Custom",
}

export class ConnectionDisplayOptionsOld implements IConnectionDisplayOptionsOld {
  customString?: string;
  displayIpAddress?: boolean;
  displayHostName?: boolean;
  displayDomainName?: boolean;
  displayCustomString?: boolean;

  constructor(data?: IConnectionDisplayOptionsOld) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.customString = data["CustomString"] !== undefined ? data["CustomString"] : <any>null;
          this.displayIpAddress = data["DisplayIpAddress"] !== undefined ? data["DisplayIpAddress"] : <any>null;
          this.displayHostName = data["DisplayHostName"] !== undefined ? data["DisplayHostName"] : <any>null;
          this.displayDomainName = data["DisplayDomainName"] !== undefined ? data["DisplayDomainName"] : <any>null;
          this.displayCustomString = data["DisplayCustomString"] !== undefined ? data["DisplayCustomString"] : <any>null;
      }
  }

  static fromJS(data: any): ConnectionDisplayOptionsOld {
      let result = new ConnectionDisplayOptionsOld();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["CustomString"] = this.customString !== undefined ? this.customString : <any>null;
      data["DisplayIpAddress"] = this.displayIpAddress !== undefined ? this.displayIpAddress : <any>null;
      data["DisplayHostName"] = this.displayHostName !== undefined ? this.displayHostName : <any>null;
      data["DisplayDomainName"] = this.displayDomainName !== undefined ? this.displayDomainName : <any>null;
      data["DisplayCustomString"] = this.displayCustomString !== undefined ? this.displayCustomString : <any>null;
      return data;
  }
}

export interface IConnectionDisplayOptionsOld {
  customString?: string;
  displayIpAddress?: boolean;
  displayHostName?: boolean;
  displayDomainName?: boolean;
  displayCustomString?: boolean;
}

export class AudioVideoInputOutput extends DevicePropertyDocument implements IAudioVideoInputOutput {
  inputs?: InputOutput[];
  outputs?: InputOutput[];
  mics?: MicrphoneItem[];

  constructor(data?: IAudioVideoInputOutput) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          if (data["Inputs"] && data["Inputs"].constructor === Array) {
              this.inputs = [];
              for (let item of data["Inputs"])
                  this.inputs.push(InputOutput.fromJS(item));
          }
          if (data["Outputs"] && data["Outputs"].constructor === Array) {
              this.outputs = [];
              for (let item of data["Outputs"])
                  this.outputs.push(InputOutput.fromJS(item));
          }
          if (data["Mics"] && data["Mics"].constructor === Array) {
              this.mics = [];
              for (let item of data["Mics"])
                  this.mics.push(MicrphoneItem.fromJS(item));
          }
      }
  }

  static fromJS(data: any): AudioVideoInputOutput {
      let result = new AudioVideoInputOutput();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.inputs && this.inputs.constructor === Array) {
          data["Inputs"] = [];
          for (let item of this.inputs)
              data["Inputs"].push(item.toJSON());
      }
      if (this.outputs && this.outputs.constructor === Array) {
          data["Outputs"] = [];
          for (let item of this.outputs)
              data["Outputs"].push(item.toJSON());
      }
      if (this.mics && this.mics.constructor === Array) {
          data["Mics"] = [];
          for (let item of this.mics)
              data["Mics"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IAudioVideoInputOutput extends IDevicePropertyDocument {
  inputs?: InputOutput[];
  outputs?: InputOutput[];
  mics?: MicrphoneItem[];
}

export class InputOutput implements IInputOutput {
  name?: string;
  uuid?: string;
  videoPortTypeSelect?: string;
  ports?: Port[];

  constructor(data?: IInputOutput) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.uuid = data["uuid"] !== undefined ? data["uuid"] : <any>null;
          this.videoPortTypeSelect = data["VideoPortTypeSelect"] !== undefined ? data["VideoPortTypeSelect"] : <any>null;
          if (data["Ports"] && data["Ports"].constructor === Array) {
              this.ports = [];
              for (let item of data["Ports"])
                  this.ports.push(Port.fromJS(item));
          }
      }
  }

  static fromJS(data: any): InputOutput {
      let result = new InputOutput();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["uuid"] = this.uuid !== undefined ? this.uuid : <any>null;
      data["VideoPortTypeSelect"] = this.videoPortTypeSelect !== undefined ? this.videoPortTypeSelect : <any>null;
      if (this.ports && this.ports.constructor === Array) {
          data["Ports"] = [];
          for (let item of this.ports)
              data["Ports"].push(item.toJSON());
      }
      return data;
  }
}

export interface IInputOutput {
  name?: string;
  uuid?: string;
  videoPortTypeSelect?: string;
  ports?: Port[];
}

export class Port implements IPort {
  uuid?: string;
  portType?: string;
  isSyncDetected?: boolean;
  isSourceDetected?: boolean;
  isSinkConnected?: boolean;
  isInterlacedDetected?: boolean;
  horizontalResolution?: number;
  verticalResolution?: number;
  framesPerSecond?: number;
  aspectRatio?: string;
  resolution?: string;
  name?: string;
  edid?: Edid;
  hdmi?: Hdmi;
  analog?: Analog;
  audio?: Audio;
  downstreamEdid?: DownstreamEdid;

  constructor(data?: IPort) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.uuid = data["uuid"] !== undefined ? data["uuid"] : <any>null;
          this.portType = data["PortType"] !== undefined ? data["PortType"] : <any>null;
          this.isSyncDetected = data["IsSyncDetected"] !== undefined ? data["IsSyncDetected"] : <any>null;
          this.isSourceDetected = data["IsSourceDetected"] !== undefined ? data["IsSourceDetected"] : <any>null;
          this.isSinkConnected = data["IsSinkConnected"] !== undefined ? data["IsSinkConnected"] : <any>null;
          this.isInterlacedDetected = data["IsInterlacedDetected"] !== undefined ? data["IsInterlacedDetected"] : <any>null;
          this.horizontalResolution = data["HorizontalResolution"] !== undefined ? data["HorizontalResolution"] : <any>null;
          this.verticalResolution = data["VerticalResolution"] !== undefined ? data["VerticalResolution"] : <any>null;
          this.framesPerSecond = data["FramesPerSecond"] !== undefined ? data["FramesPerSecond"] : <any>null;
          this.aspectRatio = data["AspectRatio"] !== undefined ? data["AspectRatio"] : <any>null;
          this.resolution = data["Resolution"] !== undefined ? data["Resolution"] : <any>null;
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.edid = data["Edid"] ? Edid.fromJS(data["Edid"]) : <any>null;
          this.hdmi = data["Hdmi"] ? Hdmi.fromJS(data["Hdmi"]) : <any>null;
          this.analog = data["Analog"] ? Analog.fromJS(data["Analog"]) : <any>null;
          this.audio = data["Audio"] ? Audio.fromJS(data["Audio"]) : <any>null;
          this.downstreamEdid = data["DownstreamEdid"] ? DownstreamEdid.fromJS(data["DownstreamEdid"]) : <any>null;
      }
  }

  static fromJS(data: any): Port {
      let result = new Port();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["uuid"] = this.uuid !== undefined ? this.uuid : <any>null;
      data["PortType"] = this.portType !== undefined ? this.portType : <any>null;
      data["IsSyncDetected"] = this.isSyncDetected !== undefined ? this.isSyncDetected : <any>null;
      data["IsSourceDetected"] = this.isSourceDetected !== undefined ? this.isSourceDetected : <any>null;
      data["IsSinkConnected"] = this.isSinkConnected !== undefined ? this.isSinkConnected : <any>null;
      data["IsInterlacedDetected"] = this.isInterlacedDetected !== undefined ? this.isInterlacedDetected : <any>null;
      data["HorizontalResolution"] = this.horizontalResolution !== undefined ? this.horizontalResolution : <any>null;
      data["VerticalResolution"] = this.verticalResolution !== undefined ? this.verticalResolution : <any>null;
      data["FramesPerSecond"] = this.framesPerSecond !== undefined ? this.framesPerSecond : <any>null;
      data["AspectRatio"] = this.aspectRatio !== undefined ? this.aspectRatio : <any>null;
      data["Resolution"] = this.resolution !== undefined ? this.resolution : <any>null;
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Edid"] = this.edid ? this.edid.toJSON() : <any>null;
      data["Hdmi"] = this.hdmi ? this.hdmi.toJSON() : <any>null;
      data["Analog"] = this.analog ? this.analog.toJSON() : <any>null;
      data["Audio"] = this.audio ? this.audio.toJSON() : <any>null;
      data["DownstreamEdid"] = this.downstreamEdid ? this.downstreamEdid.toJSON() : <any>null;
      return data;
  }
}

export interface IPort {
  uuid?: string;
  portType?: string;
  isSyncDetected?: boolean;
  isSourceDetected?: boolean;
  isSinkConnected?: boolean;
  isInterlacedDetected?: boolean;
  horizontalResolution?: number;
  verticalResolution?: number;
  framesPerSecond?: number;
  aspectRatio?: string;
  resolution?: string;
  name?: string;
  edid?: Edid;
  hdmi?: Hdmi;
  analog?: Analog;
  audio?: Audio;
  downstreamEdid?: DownstreamEdid;
}

export class Edid implements IEdid {
  edidList?: EdidItem[];
  currentEdid?: string;

  constructor(data?: IEdid) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          if (data["EdidList"] && data["EdidList"].constructor === Array) {
              this.edidList = [];
              for (let item of data["EdidList"])
                  this.edidList.push(EdidItem.fromJS(item));
          }
          this.currentEdid = data["CurrentEdid"] !== undefined ? data["CurrentEdid"] : <any>null;
      }
  }

  static fromJS(data: any): Edid {
      let result = new Edid();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.edidList && this.edidList.constructor === Array) {
          data["EdidList"] = [];
          for (let item of this.edidList)
              data["EdidList"].push(item.toJSON());
      }
      data["CurrentEdid"] = this.currentEdid !== undefined ? this.currentEdid : <any>null;
      return data;
  }
}

export interface IEdid {
  edidList?: EdidItem[];
  currentEdid?: string;
}

export class EdidItem implements IEdidItem {
  name?: string;
  type?: string;
  author?: string;
  id?: string;
  version?: string;
  data?: string;

  constructor(data?: IEdidItem) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
          this.author = data["Author"] !== undefined ? data["Author"] : <any>null;
          this.id = data["Id"] !== undefined ? data["Id"] : <any>null;
          this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
          this.data = data["Data"] !== undefined ? data["Data"] : <any>null;
      }
  }

  static fromJS(data: any): EdidItem {
      let result = new EdidItem();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Type"] = this.type !== undefined ? this.type : <any>null;
      data["Author"] = this.author !== undefined ? this.author : <any>null;
      data["Id"] = this.id !== undefined ? this.id : <any>null;
      data["Version"] = this.version !== undefined ? this.version : <any>null;
      data["Data"] = this.data !== undefined ? this.data : <any>null;
      return data;
  }
}

export interface IEdidItem {
  name?: string;
  type?: string;
  author?: string;
  id?: string;
  version?: string;
  data?: string;
}

export class Hdmi implements IHdmi {
  isSourceHdcpActive?: boolean;
  isHdcpSupportEnabled?: boolean;
  hdcpReceiverCapability?: string;
  hdcpState?: string;
  isCecErrorDetected?: boolean;
  status3D?: number;
  receiveCecMessage?: string;
  transmitCecMessage?: string;
  sourceHdcpState?: string;
  aspectRatio?: string;
  isBlankingDisabled?: boolean;
  isCecInError?: boolean;
  disabledByHdcp?: boolean;
  isHdcpForceDisabled?: boolean;
  hdcpTransmitterMode?: string;
  isOutputDisabled?: boolean;

  constructor(data?: IHdmi) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isSourceHdcpActive = data["IsSourceHdcpActive"] !== undefined ? data["IsSourceHdcpActive"] : <any>null;
          this.isHdcpSupportEnabled = data["IsHdcpSupportEnabled"] !== undefined ? data["IsHdcpSupportEnabled"] : <any>null;
          this.hdcpReceiverCapability = data["HdcpReceiverCapability"] !== undefined ? data["HdcpReceiverCapability"] : <any>null;
          this.hdcpState = data["HdcpState"] !== undefined ? data["HdcpState"] : <any>null;
          this.isCecErrorDetected = data["IsCecErrorDetected"] !== undefined ? data["IsCecErrorDetected"] : <any>null;
          this.status3D = data["Status3D"] !== undefined ? data["Status3D"] : <any>null;
          this.receiveCecMessage = data["ReceiveCecMessage"] !== undefined ? data["ReceiveCecMessage"] : <any>null;
          this.transmitCecMessage = data["TransmitCecMessage"] !== undefined ? data["TransmitCecMessage"] : <any>null;
          this.sourceHdcpState = data["SourceHdcpState"] !== undefined ? data["SourceHdcpState"] : <any>null;
          this.aspectRatio = data["AspectRatio"] !== undefined ? data["AspectRatio"] : <any>null;
          this.isBlankingDisabled = data["IsBlankingDisabled"] !== undefined ? data["IsBlankingDisabled"] : <any>null;
          this.isCecInError = data["IsCecInError"] !== undefined ? data["IsCecInError"] : <any>null;
          this.disabledByHdcp = data["DisabledByHdcp"] !== undefined ? data["DisabledByHdcp"] : <any>null;
          this.isHdcpForceDisabled = data["IsHdcpForceDisabled"] !== undefined ? data["IsHdcpForceDisabled"] : <any>null;
          this.hdcpTransmitterMode = data["HdcpTransmitterMode"] !== undefined ? data["HdcpTransmitterMode"] : <any>null;
          this.isOutputDisabled = data["IsOutputDisabled"] !== undefined ? data["IsOutputDisabled"] : <any>null;
      }
  }

  static fromJS(data: any): Hdmi {
      let result = new Hdmi();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsSourceHdcpActive"] = this.isSourceHdcpActive !== undefined ? this.isSourceHdcpActive : <any>null;
      data["IsHdcpSupportEnabled"] = this.isHdcpSupportEnabled !== undefined ? this.isHdcpSupportEnabled : <any>null;
      data["HdcpReceiverCapability"] = this.hdcpReceiverCapability !== undefined ? this.hdcpReceiverCapability : <any>null;
      data["HdcpState"] = this.hdcpState !== undefined ? this.hdcpState : <any>null;
      data["IsCecErrorDetected"] = this.isCecErrorDetected !== undefined ? this.isCecErrorDetected : <any>null;
      data["Status3D"] = this.status3D !== undefined ? this.status3D : <any>null;
      data["ReceiveCecMessage"] = this.receiveCecMessage !== undefined ? this.receiveCecMessage : <any>null;
      data["TransmitCecMessage"] = this.transmitCecMessage !== undefined ? this.transmitCecMessage : <any>null;
      data["SourceHdcpState"] = this.sourceHdcpState !== undefined ? this.sourceHdcpState : <any>null;
      data["AspectRatio"] = this.aspectRatio !== undefined ? this.aspectRatio : <any>null;
      data["IsBlankingDisabled"] = this.isBlankingDisabled !== undefined ? this.isBlankingDisabled : <any>null;
      data["IsCecInError"] = this.isCecInError !== undefined ? this.isCecInError : <any>null;
      data["DisabledByHdcp"] = this.disabledByHdcp !== undefined ? this.disabledByHdcp : <any>null;
      data["IsHdcpForceDisabled"] = this.isHdcpForceDisabled !== undefined ? this.isHdcpForceDisabled : <any>null;
      data["HdcpTransmitterMode"] = this.hdcpTransmitterMode !== undefined ? this.hdcpTransmitterMode : <any>null;
      data["IsOutputDisabled"] = this.isOutputDisabled !== undefined ? this.isOutputDisabled : <any>null;
      return data;
  }
}

export interface IHdmi {
  isSourceHdcpActive?: boolean;
  isHdcpSupportEnabled?: boolean;
  hdcpReceiverCapability?: string;
  hdcpState?: string;
  isCecErrorDetected?: boolean;
  status3D?: number;
  receiveCecMessage?: string;
  transmitCecMessage?: string;
  sourceHdcpState?: string;
  aspectRatio?: string;
  isBlankingDisabled?: boolean;
  isCecInError?: boolean;
  disabledByHdcp?: boolean;
  isHdcpForceDisabled?: boolean;
  hdcpTransmitterMode?: string;
  isOutputDisabled?: boolean;
}

export class Analog implements IAnalog {
  brightness?: number;
  contrast?: number;
  saturation?: number;
  hue?: number;
  disableeFreeRunMode?: number;
  vga?: Vga;
  bnc?: Bnc;

  constructor(data?: IAnalog) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.brightness = data["Brightness"] !== undefined ? data["Brightness"] : <any>null;
          this.contrast = data["Contrast"] !== undefined ? data["Contrast"] : <any>null;
          this.saturation = data["Saturation"] !== undefined ? data["Saturation"] : <any>null;
          this.hue = data["Hue"] !== undefined ? data["Hue"] : <any>null;
          this.disableeFreeRunMode = data["DisableeFreeRunMode"] !== undefined ? data["DisableeFreeRunMode"] : <any>null;
          this.vga = data["Vga"] ? Vga.fromJS(data["Vga"]) : <any>null;
          this.bnc = data["Bnc"] ? Bnc.fromJS(data["Bnc"]) : <any>null;
      }
  }

  static fromJS(data: any): Analog {
      let result = new Analog();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Brightness"] = this.brightness !== undefined ? this.brightness : <any>null;
      data["Contrast"] = this.contrast !== undefined ? this.contrast : <any>null;
      data["Saturation"] = this.saturation !== undefined ? this.saturation : <any>null;
      data["Hue"] = this.hue !== undefined ? this.hue : <any>null;
      data["DisableeFreeRunMode"] = this.disableeFreeRunMode !== undefined ? this.disableeFreeRunMode : <any>null;
      data["Vga"] = this.vga ? this.vga.toJSON() : <any>null;
      data["Bnc"] = this.bnc ? this.bnc.toJSON() : <any>null;
      return data;
  }
}

export interface IAnalog {
  brightness?: number;
  contrast?: number;
  saturation?: number;
  hue?: number;
  disableeFreeRunMode?: number;
  vga?: Vga;
  bnc?: Bnc;
}

export class Vga implements IVga {
  red?: number;
  green?: number;
  blue?: number;
  isAutocalibrateRunning?: boolean;
  typeControl?: number;

  constructor(data?: IVga) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.red = data["Red"] !== undefined ? data["Red"] : <any>null;
          this.green = data["Green"] !== undefined ? data["Green"] : <any>null;
          this.blue = data["Blue"] !== undefined ? data["Blue"] : <any>null;
          this.isAutocalibrateRunning = data["IsAutocalibrateRunning"] !== undefined ? data["IsAutocalibrateRunning"] : <any>null;
          this.typeControl = data["TypeControl"] !== undefined ? data["TypeControl"] : <any>null;
      }
  }

  static fromJS(data: any): Vga {
      let result = new Vga();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Red"] = this.red !== undefined ? this.red : <any>null;
      data["Green"] = this.green !== undefined ? this.green : <any>null;
      data["Blue"] = this.blue !== undefined ? this.blue : <any>null;
      data["IsAutocalibrateRunning"] = this.isAutocalibrateRunning !== undefined ? this.isAutocalibrateRunning : <any>null;
      data["TypeControl"] = this.typeControl !== undefined ? this.typeControl : <any>null;
      return data;
  }
}

export interface IVga {
  red?: number;
  green?: number;
  blue?: number;
  isAutocalibrateRunning?: boolean;
  typeControl?: number;
}

export class Bnc implements IBnc {
  videoTypee?: number;

  constructor(data?: IBnc) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.videoTypee = data["VideoTypee"] !== undefined ? data["VideoTypee"] : <any>null;
      }
  }

  static fromJS(data: any): Bnc {
      let result = new Bnc();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["VideoTypee"] = this.videoTypee !== undefined ? this.videoTypee : <any>null;
      return data;
  }
}

export interface IBnc {
  videoTypee?: number;
}

export class Audio implements IAudio {
  audioTypeSelect?: number;
  gain?: number;
  delay?: number;
  mute?: boolean;
  analogAudioGain?: number;
  spidifAudioGain?: number;
  bass?: number;
  treble?: number;
  volume?: number;
  digital?: Digital;

  constructor(data?: IAudio) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.audioTypeSelect = data["AudioTypeSelect"] !== undefined ? data["AudioTypeSelect"] : <any>null;
          this.gain = data["Gain"] !== undefined ? data["Gain"] : <any>null;
          this.delay = data["Delay"] !== undefined ? data["Delay"] : <any>null;
          this.mute = data["Mute"] !== undefined ? data["Mute"] : <any>null;
          this.analogAudioGain = data["AnalogAudioGain"] !== undefined ? data["AnalogAudioGain"] : <any>null;
          this.spidifAudioGain = data["SpidifAudioGain"] !== undefined ? data["SpidifAudioGain"] : <any>null;
          this.bass = data["Bass"] !== undefined ? data["Bass"] : <any>null;
          this.treble = data["Treble"] !== undefined ? data["Treble"] : <any>null;
          this.volume = data["Volume"] !== undefined ? data["Volume"] : <any>null;
          this.digital = data["Digital"] ? Digital.fromJS(data["Digital"]) : <any>null;
      }
  }

  static fromJS(data: any): Audio {
      let result = new Audio();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["AudioTypeSelect"] = this.audioTypeSelect !== undefined ? this.audioTypeSelect : <any>null;
      data["Gain"] = this.gain !== undefined ? this.gain : <any>null;
      data["Delay"] = this.delay !== undefined ? this.delay : <any>null;
      data["Mute"] = this.mute !== undefined ? this.mute : <any>null;
      data["AnalogAudioGain"] = this.analogAudioGain !== undefined ? this.analogAudioGain : <any>null;
      data["SpidifAudioGain"] = this.spidifAudioGain !== undefined ? this.spidifAudioGain : <any>null;
      data["Bass"] = this.bass !== undefined ? this.bass : <any>null;
      data["Treble"] = this.treble !== undefined ? this.treble : <any>null;
      data["Volume"] = this.volume !== undefined ? this.volume : <any>null;
      data["Digital"] = this.digital ? this.digital.toJSON() : <any>null;
      return data;
  }
}

export interface IAudio {
  audioTypeSelect?: number;
  gain?: number;
  delay?: number;
  mute?: boolean;
  analogAudioGain?: number;
  spidifAudioGain?: number;
  bass?: number;
  treble?: number;
  volume?: number;
  digital?: Digital;
}

export class Digital implements IDigital {
  isAudioSourceDetected?: boolean;
  channels?: number;
  format?: string;

  constructor(data?: IDigital) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isAudioSourceDetected = data["IsAudioSourceDetected"] !== undefined ? data["IsAudioSourceDetected"] : <any>null;
          this.channels = data["Channels"] !== undefined ? data["Channels"] : <any>null;
          this.format = data["Format"] !== undefined ? data["Format"] : <any>null;
      }
  }

  static fromJS(data: any): Digital {
      let result = new Digital();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsAudioSourceDetected"] = this.isAudioSourceDetected !== undefined ? this.isAudioSourceDetected : <any>null;
      data["Channels"] = this.channels !== undefined ? this.channels : <any>null;
      data["Format"] = this.format !== undefined ? this.format : <any>null;
      return data;
  }
}

export interface IDigital {
  isAudioSourceDetected?: boolean;
  channels?: number;
  format?: string;
}

export class DownstreamEdid implements IDownstreamEdid {
  manufacturerString?: string;
  serialNumberString?: string;
  nameString?: string;
  prefTimingString?: string;

  constructor(data?: IDownstreamEdid) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.manufacturerString = data["ManufacturerString"] !== undefined ? data["ManufacturerString"] : <any>null;
          this.serialNumberString = data["SerialNumberString"] !== undefined ? data["SerialNumberString"] : <any>null;
          this.nameString = data["NameString"] !== undefined ? data["NameString"] : <any>null;
          this.prefTimingString = data["PrefTimingString"] !== undefined ? data["PrefTimingString"] : <any>null;
      }
  }

  static fromJS(data: any): DownstreamEdid {
      let result = new DownstreamEdid();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["ManufacturerString"] = this.manufacturerString !== undefined ? this.manufacturerString : <any>null;
      data["SerialNumberString"] = this.serialNumberString !== undefined ? this.serialNumberString : <any>null;
      data["NameString"] = this.nameString !== undefined ? this.nameString : <any>null;
      data["PrefTimingString"] = this.prefTimingString !== undefined ? this.prefTimingString : <any>null;
      return data;
  }
}

export interface IDownstreamEdid {
  manufacturerString?: string;
  serialNumberString?: string;
  nameString?: string;
  prefTimingString?: string;
}

export class MicrphoneItem implements IMicrphoneItem {
  name?: string;
  type?: string;
  microphone?: Microphone;

  constructor(data?: IMicrphoneItem) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
          this.microphone = data["Microphone"] ? Microphone.fromJS(data["Microphone"]) : <any>null;
      }
  }

  static fromJS(data: any): MicrphoneItem {
      let result = new MicrphoneItem();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Type"] = this.type !== undefined ? this.type : <any>null;
      data["Microphone"] = this.microphone ? this.microphone.toJSON() : <any>null;
      return data;
  }
}

export interface IMicrphoneItem {
  name?: string;
  type?: string;
  microphone?: Microphone;
}

export class Microphone implements IMicrophone {
  gain?: number;
  delay?: number;
  isMuted?: boolean;
  vuLevel?: number;
  gate?: MicSettings;
  compressor?: MicSettings;
  limiter?: MicSettings;
  eQ?: EQ;
  phantomPower?: PhantomPower;

  constructor(data?: IMicrophone) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.gain = data["Gain"] !== undefined ? data["Gain"] : <any>null;
          this.delay = data["Delay"] !== undefined ? data["Delay"] : <any>null;
          this.isMuted = data["IsMuted"] !== undefined ? data["IsMuted"] : <any>null;
          this.vuLevel = data["VuLevel"] !== undefined ? data["VuLevel"] : <any>null;
          this.gate = data["Gate"] ? MicSettings.fromJS(data["Gate"]) : <any>null;
          this.compressor = data["Compressor"] ? MicSettings.fromJS(data["Compressor"]) : <any>null;
          this.limiter = data["Limiter"] ? MicSettings.fromJS(data["Limiter"]) : <any>null;
          this.eQ = data["EQ"] ? EQ.fromJS(data["EQ"]) : <any>null;
          this.phantomPower = data["PhantomPower"] ? PhantomPower.fromJS(data["PhantomPower"]) : <any>null;
      }
  }

  static fromJS(data: any): Microphone {
      let result = new Microphone();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Gain"] = this.gain !== undefined ? this.gain : <any>null;
      data["Delay"] = this.delay !== undefined ? this.delay : <any>null;
      data["IsMuted"] = this.isMuted !== undefined ? this.isMuted : <any>null;
      data["VuLevel"] = this.vuLevel !== undefined ? this.vuLevel : <any>null;
      data["Gate"] = this.gate ? this.gate.toJSON() : <any>null;
      data["Compressor"] = this.compressor ? this.compressor.toJSON() : <any>null;
      data["Limiter"] = this.limiter ? this.limiter.toJSON() : <any>null;
      data["EQ"] = this.eQ ? this.eQ.toJSON() : <any>null;
      data["PhantomPower"] = this.phantomPower ? this.phantomPower.toJSON() : <any>null;
      return data;
  }
}

export interface IMicrophone {
  gain?: number;
  delay?: number;
  isMuted?: boolean;
  vuLevel?: number;
  gate?: MicSettings;
  compressor?: MicSettings;
  limiter?: MicSettings;
  eQ?: EQ;
  phantomPower?: PhantomPower;
}

export class MicSettings implements IMicSettings {
  isEnabled?: boolean;
  isGating?: boolean;
  isNominal?: boolean;
  isClipping?: boolean;
  isThresholdReached?: boolean;
  isSoftKneeEnabled?: boolean;
  threshold?: number;
  ratio?: number;
  level?: number;
  depth?: number;
  attack?: number;
  release?: number;

  constructor(data?: IMicSettings) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.isGating = data["IsGating"] !== undefined ? data["IsGating"] : <any>null;
          this.isNominal = data["IsNominal"] !== undefined ? data["IsNominal"] : <any>null;
          this.isClipping = data["IsClipping"] !== undefined ? data["IsClipping"] : <any>null;
          this.isThresholdReached = data["IsThresholdReached"] !== undefined ? data["IsThresholdReached"] : <any>null;
          this.isSoftKneeEnabled = data["IsSoftKneeEnabled"] !== undefined ? data["IsSoftKneeEnabled"] : <any>null;
          this.threshold = data["Threshold"] !== undefined ? data["Threshold"] : <any>null;
          this.ratio = data["Ratio"] !== undefined ? data["Ratio"] : <any>null;
          this.level = data["Level"] !== undefined ? data["Level"] : <any>null;
          this.depth = data["Depth"] !== undefined ? data["Depth"] : <any>null;
          this.attack = data["Attack"] !== undefined ? data["Attack"] : <any>null;
          this.release = data["Release"] !== undefined ? data["Release"] : <any>null;
      }
  }

  static fromJS(data: any): MicSettings {
      let result = new MicSettings();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["IsGating"] = this.isGating !== undefined ? this.isGating : <any>null;
      data["IsNominal"] = this.isNominal !== undefined ? this.isNominal : <any>null;
      data["IsClipping"] = this.isClipping !== undefined ? this.isClipping : <any>null;
      data["IsThresholdReached"] = this.isThresholdReached !== undefined ? this.isThresholdReached : <any>null;
      data["IsSoftKneeEnabled"] = this.isSoftKneeEnabled !== undefined ? this.isSoftKneeEnabled : <any>null;
      data["Threshold"] = this.threshold !== undefined ? this.threshold : <any>null;
      data["Ratio"] = this.ratio !== undefined ? this.ratio : <any>null;
      data["Level"] = this.level !== undefined ? this.level : <any>null;
      data["Depth"] = this.depth !== undefined ? this.depth : <any>null;
      data["Attack"] = this.attack !== undefined ? this.attack : <any>null;
      data["Release"] = this.release !== undefined ? this.release : <any>null;
      return data;
  }
}

export interface IMicSettings {
  isEnabled?: boolean;
  isGating?: boolean;
  isNominal?: boolean;
  isClipping?: boolean;
  isThresholdReached?: boolean;
  isSoftKneeEnabled?: boolean;
  threshold?: number;
  ratio?: number;
  level?: number;
  depth?: number;
  attack?: number;
  release?: number;
}

export class EQ implements IEQ {
  isHighPassFilterEnabled?: boolean;
  highBandFrequency?: number;
  highMidBandFrequency?: number;
  highBandGain?: number;
  highMidBandGain?: number;
  lowMidBandFrequency?: number;
  lowBandFrequency?: number;
  lowMidBandGain?: number;
  lowBandGain?: number;

  constructor(data?: IEQ) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isHighPassFilterEnabled = data["IsHighPassFilterEnabled"] !== undefined ? data["IsHighPassFilterEnabled"] : <any>null;
          this.highBandFrequency = data["HighBandFrequency"] !== undefined ? data["HighBandFrequency"] : <any>null;
          this.highMidBandFrequency = data["HighMidBandFrequency"] !== undefined ? data["HighMidBandFrequency"] : <any>null;
          this.highBandGain = data["HighBandGain"] !== undefined ? data["HighBandGain"] : <any>null;
          this.highMidBandGain = data["HighMidBandGain"] !== undefined ? data["HighMidBandGain"] : <any>null;
          this.lowMidBandFrequency = data["LowMidBandFrequency"] !== undefined ? data["LowMidBandFrequency"] : <any>null;
          this.lowBandFrequency = data["LowBandFrequency"] !== undefined ? data["LowBandFrequency"] : <any>null;
          this.lowMidBandGain = data["LowMidBandGain"] !== undefined ? data["LowMidBandGain"] : <any>null;
          this.lowBandGain = data["LowBandGain"] !== undefined ? data["LowBandGain"] : <any>null;
      }
  }

  static fromJS(data: any): EQ {
      let result = new EQ();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsHighPassFilterEnabled"] = this.isHighPassFilterEnabled !== undefined ? this.isHighPassFilterEnabled : <any>null;
      data["HighBandFrequency"] = this.highBandFrequency !== undefined ? this.highBandFrequency : <any>null;
      data["HighMidBandFrequency"] = this.highMidBandFrequency !== undefined ? this.highMidBandFrequency : <any>null;
      data["HighBandGain"] = this.highBandGain !== undefined ? this.highBandGain : <any>null;
      data["HighMidBandGain"] = this.highMidBandGain !== undefined ? this.highMidBandGain : <any>null;
      data["LowMidBandFrequency"] = this.lowMidBandFrequency !== undefined ? this.lowMidBandFrequency : <any>null;
      data["LowBandFrequency"] = this.lowBandFrequency !== undefined ? this.lowBandFrequency : <any>null;
      data["LowMidBandGain"] = this.lowMidBandGain !== undefined ? this.lowMidBandGain : <any>null;
      data["LowBandGain"] = this.lowBandGain !== undefined ? this.lowBandGain : <any>null;
      return data;
  }
}

export interface IEQ {
  isHighPassFilterEnabled?: boolean;
  highBandFrequency?: number;
  highMidBandFrequency?: number;
  highBandGain?: number;
  highMidBandGain?: number;
  lowMidBandFrequency?: number;
  lowBandFrequency?: number;
  lowMidBandGain?: number;
  lowBandGain?: number;
}

export class PhantomPower implements IPhantomPower {
  isEnabled?: boolean;

  constructor(data?: IPhantomPower) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
      }
  }

  static fromJS(data: any): PhantomPower {
      let result = new PhantomPower();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      return data;
  }
}

export interface IPhantomPower {
  isEnabled?: boolean;
}

export class App extends DevicePropertyDocument implements IApp {
  config?: Settings;
  runTime?: RunTime;

  constructor(data?: IApp) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.config = data["Config"] ? Settings.fromJS(data["Config"]) : <any>null;
          this.runTime = data["RunTime"] ? RunTime.fromJS(data["RunTime"]) : <any>null;
      }
  }

  static fromJS(data: any): App {
      let result = new App();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Config"] = this.config ? this.config.toJSON() : <any>null;
      data["RunTime"] = this.runTime ? this.runTime.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IApp extends IDevicePropertyDocument {
  config?: Settings;
  runTime?: RunTime;
}

export class Settings_2_0_0 implements ISettings_2_0_0 {
  deviceAppModel?: string;
  contentVersion?: string;
  contentTimestamp?: Date;
  general?: General_2_0_0;
  runTimeSettings?: RunTimeSettings_2_0_0;
  timeOptions?: TimeOptions;
  fusionSetup?: FusionSetup;
  audioDevices?: AudioDevices_2_0_0;
  scheduling?: Scheduling;
  videoDisplay?: VideoDisplay;

  constructor(data?: ISettings_2_0_0) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.deviceAppModel = data["DeviceAppModel"] !== undefined ? data["DeviceAppModel"] : <any>null;
          this.contentVersion = data["ContentVersion"] !== undefined ? data["ContentVersion"] : <any>null;
          this.contentTimestamp = data["ContentTimestamp"] ? new Date(data["ContentTimestamp"].toString()) : <any>null;
          this.general = data["General"] ? General_2_0_0.fromJS(data["General"]) : <any>null;
          this.runTimeSettings = data["RunTimeSettings"] ? RunTimeSettings_2_0_0.fromJS(data["RunTimeSettings"]) : <any>null;
          this.timeOptions = data["TimeOptions"] ? TimeOptions.fromJS(data["TimeOptions"]) : <any>null;
          this.fusionSetup = data["FusionSetup"] ? FusionSetup.fromJS(data["FusionSetup"]) : <any>null;
          this.audioDevices = data["AudioDevices"] ? AudioDevices_2_0_0.fromJS(data["AudioDevices"]) : <any>null;
          this.scheduling = data["Scheduling"] ? Scheduling.fromJS(data["Scheduling"]) : <any>null;
          this.videoDisplay = data["VideoDisplay"] ? VideoDisplay.fromJS(data["VideoDisplay"]) : <any>null;
      }
  }

  static fromJS(data: any): Settings_2_0_0 {
      let result = new Settings_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DeviceAppModel"] = this.deviceAppModel !== undefined ? this.deviceAppModel : <any>null;
      data["ContentVersion"] = this.contentVersion !== undefined ? this.contentVersion : <any>null;
      data["ContentTimestamp"] = this.contentTimestamp ? this.contentTimestamp.toISOString() : <any>null;
      data["General"] = this.general ? this.general.toJSON() : <any>null;
      data["RunTimeSettings"] = this.runTimeSettings ? this.runTimeSettings.toJSON() : <any>null;
      data["TimeOptions"] = this.timeOptions ? this.timeOptions.toJSON() : <any>null;
      data["FusionSetup"] = this.fusionSetup ? this.fusionSetup.toJSON() : <any>null;
      data["AudioDevices"] = this.audioDevices ? this.audioDevices.toJSON() : <any>null;
      data["Scheduling"] = this.scheduling ? this.scheduling.toJSON() : <any>null;
      data["VideoDisplay"] = this.videoDisplay ? this.videoDisplay.toJSON() : <any>null;
      return data;
  }
}

export interface ISettings_2_0_0 {
  deviceAppModel?: string;
  contentVersion?: string;
  contentTimestamp?: Date;
  general?: General_2_0_0;
  runTimeSettings?: RunTimeSettings_2_0_0;
  timeOptions?: TimeOptions;
  fusionSetup?: FusionSetup;
  audioDevices?: AudioDevices_2_0_0;
  scheduling?: Scheduling;
  videoDisplay?: VideoDisplay;
}

export class Settings extends Settings_2_0_0 implements ISettings {
  general?: General;
  runTimeSettings?: RunTimeSettings;
  audioDevices?: AudioDevices;

  constructor(data?: ISettings) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.general = data["General"] ? General.fromJS(data["General"]) : <any>null;
          this.runTimeSettings = data["RunTimeSettings"] ? RunTimeSettings.fromJS(data["RunTimeSettings"]) : <any>null;
          this.audioDevices = data["AudioDevices"] ? AudioDevices.fromJS(data["AudioDevices"]) : <any>null;
      }
  }

  static fromJS(data: any): Settings {
      let result = new Settings();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["General"] = this.general ? this.general.toJSON() : <any>null;
      data["RunTimeSettings"] = this.runTimeSettings ? this.runTimeSettings.toJSON() : <any>null;
      data["AudioDevices"] = this.audioDevices ? this.audioDevices.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ISettings extends ISettings_2_0_0 {
  general?: General;
  runTimeSettings?: RunTimeSettings;
  audioDevices?: AudioDevices;
}

export class General_2_0_0 implements IGeneral_2_0_0 {
  language?: string;
  roomName?: string;
  powerControlOptions?: string;

  constructor(data?: IGeneral_2_0_0) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.language = data["Language"] !== undefined ? data["Language"] : <any>null;
          this.roomName = data["RoomName"] !== undefined ? data["RoomName"] : <any>null;
          this.powerControlOptions = data["PowerControlOptions"] !== undefined ? data["PowerControlOptions"] : <any>null;
      }
  }

  static fromJS(data: any): General_2_0_0 {
      let result = new General_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Language"] = this.language !== undefined ? this.language : <any>null;
      data["RoomName"] = this.roomName !== undefined ? this.roomName : <any>null;
      data["PowerControlOptions"] = this.powerControlOptions !== undefined ? this.powerControlOptions : <any>null;
      return data;
  }
}

export interface IGeneral_2_0_0 {
  language?: string;
  roomName?: string;
  powerControlOptions?: string;
}

export class General extends General_2_0_0 implements IGeneral {
  powerSchedule?: PowerSchedule;

  constructor(data?: IGeneral) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.powerSchedule = data["PowerSchedule"] ? PowerSchedule.fromJS(data["PowerSchedule"]) : <any>null;
      }
  }

  static fromJS(data: any): General {
      let result = new General();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["PowerSchedule"] = this.powerSchedule ? this.powerSchedule.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IGeneral extends IGeneral_2_0_0 {
  powerSchedule?: PowerSchedule;
}

export class PowerSchedule implements IPowerSchedule {
  monday?: ScheduleTime;
  tuesday?: ScheduleTime;
  wednesday?: ScheduleTime;
  thursday?: ScheduleTime;
  friday?: ScheduleTime;
  saturday?: ScheduleTime;
  sunday?: ScheduleTime;

  constructor(data?: IPowerSchedule) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.monday = data["Monday"] ? ScheduleTime.fromJS(data["Monday"]) : <any>null;
          this.tuesday = data["Tuesday"] ? ScheduleTime.fromJS(data["Tuesday"]) : <any>null;
          this.wednesday = data["Wednesday"] ? ScheduleTime.fromJS(data["Wednesday"]) : <any>null;
          this.thursday = data["Thursday"] ? ScheduleTime.fromJS(data["Thursday"]) : <any>null;
          this.friday = data["Friday"] ? ScheduleTime.fromJS(data["Friday"]) : <any>null;
          this.saturday = data["Saturday"] ? ScheduleTime.fromJS(data["Saturday"]) : <any>null;
          this.sunday = data["Sunday"] ? ScheduleTime.fromJS(data["Sunday"]) : <any>null;
      }
  }

  static fromJS(data: any): PowerSchedule {
      let result = new PowerSchedule();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Monday"] = this.monday ? this.monday.toJSON() : <any>null;
      data["Tuesday"] = this.tuesday ? this.tuesday.toJSON() : <any>null;
      data["Wednesday"] = this.wednesday ? this.wednesday.toJSON() : <any>null;
      data["Thursday"] = this.thursday ? this.thursday.toJSON() : <any>null;
      data["Friday"] = this.friday ? this.friday.toJSON() : <any>null;
      data["Saturday"] = this.saturday ? this.saturday.toJSON() : <any>null;
      data["Sunday"] = this.sunday ? this.sunday.toJSON() : <any>null;
      return data;
  }
}

export interface IPowerSchedule {
  monday?: ScheduleTime;
  tuesday?: ScheduleTime;
  wednesday?: ScheduleTime;
  thursday?: ScheduleTime;
  friday?: ScheduleTime;
  saturday?: ScheduleTime;
  sunday?: ScheduleTime;
}

export class ScheduleTime implements IScheduleTime {
  isEnabled?: boolean;
  onTime?: string;
  offTime?: string;

  constructor(data?: IScheduleTime) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.onTime = data["OnTime"] !== undefined ? data["OnTime"] : <any>null;
          this.offTime = data["OffTime"] !== undefined ? data["OffTime"] : <any>null;
      }
  }

  static fromJS(data: any): ScheduleTime {
      let result = new ScheduleTime();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["OnTime"] = this.onTime !== undefined ? this.onTime : <any>null;
      data["OffTime"] = this.offTime !== undefined ? this.offTime : <any>null;
      return data;
  }
}

export interface IScheduleTime {
  isEnabled?: boolean;
  onTime?: string;
  offTime?: string;
}

export class RunTimeSettings_2_0_0 implements IRunTimeSettings_2_0_0 {
  hideMeetingSubject?: boolean;
  hideMeetingOrganizer?: boolean;
  enableCallNotification?: boolean;
  hideWiredCableConnection?: boolean;
  cableConnectionDetails?: string;
  nextMeetingInformationMinutesBeforeMeetingStart?: number;
  timeRemainingMessageStartsMinutes?: number;
  timeRemainingMessageDurationSeconds?: number;
  emergencyBroadcastTimeoutMinutes?: number;
  nonEmergencyBroadcastTimeoutMinutes?: number;
  callNotificationTimeoutSeconds?: number;
  logo?: Logo;
  backgrounds?: Background;

  constructor(data?: IRunTimeSettings_2_0_0) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.hideMeetingSubject = data["HideMeetingSubject"] !== undefined ? data["HideMeetingSubject"] : <any>null;
          this.hideMeetingOrganizer = data["HideMeetingOrganizer"] !== undefined ? data["HideMeetingOrganizer"] : <any>null;
          this.enableCallNotification = data["EnableCallNotification"] !== undefined ? data["EnableCallNotification"] : <any>null;
          this.hideWiredCableConnection = data["HideWiredCableConnection"] !== undefined ? data["HideWiredCableConnection"] : <any>null;
          this.cableConnectionDetails = data["CableConnectionDetails"] !== undefined ? data["CableConnectionDetails"] : <any>null;
          this.nextMeetingInformationMinutesBeforeMeetingStart = data["NextMeetingInformationMinutesBeforeMeetingStart"] !== undefined ? data["NextMeetingInformationMinutesBeforeMeetingStart"] : <any>null;
          this.timeRemainingMessageStartsMinutes = data["TimeRemainingMessageStartsMinutes"] !== undefined ? data["TimeRemainingMessageStartsMinutes"] : <any>null;
          this.timeRemainingMessageDurationSeconds = data["TimeRemainingMessageDurationSeconds"] !== undefined ? data["TimeRemainingMessageDurationSeconds"] : <any>null;
          this.emergencyBroadcastTimeoutMinutes = data["EmergencyBroadcastTimeoutMinutes"] !== undefined ? data["EmergencyBroadcastTimeoutMinutes"] : <any>null;
          this.nonEmergencyBroadcastTimeoutMinutes = data["NonEmergencyBroadcastTimeoutMinutes"] !== undefined ? data["NonEmergencyBroadcastTimeoutMinutes"] : <any>null;
          this.callNotificationTimeoutSeconds = data["CallNotificationTimeoutSeconds"] !== undefined ? data["CallNotificationTimeoutSeconds"] : <any>null;
          this.logo = data["Logo"] ? Logo.fromJS(data["Logo"]) : <any>null;
          this.backgrounds = data["Backgrounds"] ? Background.fromJS(data["Backgrounds"]) : <any>null;
      }
  }

  static fromJS(data: any): RunTimeSettings_2_0_0 {
      let result = new RunTimeSettings_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["HideMeetingSubject"] = this.hideMeetingSubject !== undefined ? this.hideMeetingSubject : <any>null;
      data["HideMeetingOrganizer"] = this.hideMeetingOrganizer !== undefined ? this.hideMeetingOrganizer : <any>null;
      data["EnableCallNotification"] = this.enableCallNotification !== undefined ? this.enableCallNotification : <any>null;
      data["HideWiredCableConnection"] = this.hideWiredCableConnection !== undefined ? this.hideWiredCableConnection : <any>null;
      data["CableConnectionDetails"] = this.cableConnectionDetails !== undefined ? this.cableConnectionDetails : <any>null;
      data["NextMeetingInformationMinutesBeforeMeetingStart"] = this.nextMeetingInformationMinutesBeforeMeetingStart !== undefined ? this.nextMeetingInformationMinutesBeforeMeetingStart : <any>null;
      data["TimeRemainingMessageStartsMinutes"] = this.timeRemainingMessageStartsMinutes !== undefined ? this.timeRemainingMessageStartsMinutes : <any>null;
      data["TimeRemainingMessageDurationSeconds"] = this.timeRemainingMessageDurationSeconds !== undefined ? this.timeRemainingMessageDurationSeconds : <any>null;
      data["EmergencyBroadcastTimeoutMinutes"] = this.emergencyBroadcastTimeoutMinutes !== undefined ? this.emergencyBroadcastTimeoutMinutes : <any>null;
      data["NonEmergencyBroadcastTimeoutMinutes"] = this.nonEmergencyBroadcastTimeoutMinutes !== undefined ? this.nonEmergencyBroadcastTimeoutMinutes : <any>null;
      data["CallNotificationTimeoutSeconds"] = this.callNotificationTimeoutSeconds !== undefined ? this.callNotificationTimeoutSeconds : <any>null;
      data["Logo"] = this.logo ? this.logo.toJSON() : <any>null;
      data["Backgrounds"] = this.backgrounds ? this.backgrounds.toJSON() : <any>null;
      return data;
  }
}

export interface IRunTimeSettings_2_0_0 {
  hideMeetingSubject?: boolean;
  hideMeetingOrganizer?: boolean;
  enableCallNotification?: boolean;
  hideWiredCableConnection?: boolean;
  cableConnectionDetails?: string;
  nextMeetingInformationMinutesBeforeMeetingStart?: number;
  timeRemainingMessageStartsMinutes?: number;
  timeRemainingMessageDurationSeconds?: number;
  emergencyBroadcastTimeoutMinutes?: number;
  nonEmergencyBroadcastTimeoutMinutes?: number;
  callNotificationTimeoutSeconds?: number;
  logo?: Logo;
  backgrounds?: Background;
}

export class RunTimeSettings extends RunTimeSettings_2_0_0 implements IRunTimeSettings {
  showOverlay?: boolean;
  connectionDetailsLayout?: ConnectionDetailsLayout;
  showCalendarClockOverlay?: boolean;
  showBroadcastMessage?: boolean;
  isHdmiInputEnabled?: boolean;
  touchScreenBackgrounds?: TouchScreenBackgrounds;

  constructor(data?: IRunTimeSettings) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.showOverlay = data["ShowOverlay"] !== undefined ? data["ShowOverlay"] : <any>null;
          this.connectionDetailsLayout = data["ConnectionDetailsLayout"] !== undefined ? data["ConnectionDetailsLayout"] : <any>null;
          this.showCalendarClockOverlay = data["ShowCalendarClockOverlay"] !== undefined ? data["ShowCalendarClockOverlay"] : <any>null;
          this.showBroadcastMessage = data["ShowBroadcastMessage"] !== undefined ? data["ShowBroadcastMessage"] : <any>null;
          this.isHdmiInputEnabled = data["IsHdmiInputEnabled"] !== undefined ? data["IsHdmiInputEnabled"] : <any>null;
          this.touchScreenBackgrounds = data["TouchScreenBackgrounds"] ? TouchScreenBackgrounds.fromJS(data["TouchScreenBackgrounds"]) : <any>null;
      }
  }

  static fromJS(data: any): RunTimeSettings {
      let result = new RunTimeSettings();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["ShowOverlay"] = this.showOverlay !== undefined ? this.showOverlay : <any>null;
      data["ConnectionDetailsLayout"] = this.connectionDetailsLayout !== undefined ? this.connectionDetailsLayout : <any>null;
      data["ShowCalendarClockOverlay"] = this.showCalendarClockOverlay !== undefined ? this.showCalendarClockOverlay : <any>null;
      data["ShowBroadcastMessage"] = this.showBroadcastMessage !== undefined ? this.showBroadcastMessage : <any>null;
      data["IsHdmiInputEnabled"] = this.isHdmiInputEnabled !== undefined ? this.isHdmiInputEnabled : <any>null;
      data["TouchScreenBackgrounds"] = this.touchScreenBackgrounds ? this.touchScreenBackgrounds.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IRunTimeSettings extends IRunTimeSettings_2_0_0 {
  showOverlay?: boolean;
  connectionDetailsLayout?: ConnectionDetailsLayout;
  showCalendarClockOverlay?: boolean;
  showBroadcastMessage?: boolean;
  isHdmiInputEnabled?: boolean;
  touchScreenBackgrounds?: TouchScreenBackgrounds;
}

export enum ConnectionDetailsLayout {
  Bottom = <any>"Bottom",
  Right = <any>"Right",
  Left = <any>"Left",
}

export class TouchScreenBackgrounds implements ITouchScreenBackgrounds {
  enableTouchScreenBackgrounds?: boolean;
  touchScreenBackgroundSelection?: TouchScreenBackgroundSelection;

  constructor(data?: ITouchScreenBackgrounds) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enableTouchScreenBackgrounds = data["EnableTouchScreenBackgrounds"] !== undefined ? data["EnableTouchScreenBackgrounds"] : <any>null;
          this.touchScreenBackgroundSelection = data["TouchScreenBackgroundSelection"] !== undefined ? data["TouchScreenBackgroundSelection"] : <any>null;
      }
  }

  static fromJS(data: any): TouchScreenBackgrounds {
      let result = new TouchScreenBackgrounds();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["EnableTouchScreenBackgrounds"] = this.enableTouchScreenBackgrounds !== undefined ? this.enableTouchScreenBackgrounds : <any>null;
      data["TouchScreenBackgroundSelection"] = this.touchScreenBackgroundSelection !== undefined ? this.touchScreenBackgroundSelection : <any>null;
      return data;
  }
}

export interface ITouchScreenBackgrounds {
  enableTouchScreenBackgrounds?: boolean;
  touchScreenBackgroundSelection?: TouchScreenBackgroundSelection;
}

export enum TouchScreenBackgroundSelection {
  CruxUi1 = <any>"CruxUi1",
  CruxUi2 = <any>"CruxUi2",
  CruxUi3 = <any>"CruxUi3",
  Agriculture = <any>"Agriculture",
  Educational = <any>"Educational",
  Financial = <any>"Financial",
  Government = <any>"Government",
  Hospitality = <any>"Hospitality",
  Law = <any>"Law",
  OilAndGas = <any>"OilAndGas",
  Pharmaceutical = <any>"Pharmaceutical",
  Technology = <any>"Technology",
}

export class Logo implements ILogo {
  enableCustomLogoGraphic?: boolean;
  customLogoGraphicURL?: string;

  constructor(data?: ILogo) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enableCustomLogoGraphic = data["EnableCustomLogoGraphic"] !== undefined ? data["EnableCustomLogoGraphic"] : <any>null;
          this.customLogoGraphicURL = data["CustomLogoGraphicURL"] !== undefined ? data["CustomLogoGraphicURL"] : <any>null;
      }
  }

  static fromJS(data: any): Logo {
      let result = new Logo();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["EnableCustomLogoGraphic"] = this.enableCustomLogoGraphic !== undefined ? this.enableCustomLogoGraphic : <any>null;
      data["CustomLogoGraphicURL"] = this.customLogoGraphicURL !== undefined ? this.customLogoGraphicURL : <any>null;
      return data;
  }
}

export interface ILogo {
  enableCustomLogoGraphic?: boolean;
  customLogoGraphicURL?: string;
}

export class Background implements IBackground {
  enableCustomBackgrounds?: boolean;
  intervalBetweenBackgroundsSeconds?: number;
  customBackgroundList?: CustomBackground[];
  backGroundOverlay?: boolean;

  constructor(data?: IBackground) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enableCustomBackgrounds = data["EnableCustomBackgrounds"] !== undefined ? data["EnableCustomBackgrounds"] : <any>null;
          this.intervalBetweenBackgroundsSeconds = data["IntervalBetweenBackgroundsSeconds"] !== undefined ? data["IntervalBetweenBackgroundsSeconds"] : <any>null;
          if (data["CustomBackgroundList"] && data["CustomBackgroundList"].constructor === Array) {
              this.customBackgroundList = [];
              for (let item of data["CustomBackgroundList"])
                  this.customBackgroundList.push(CustomBackground.fromJS(item));
          }
          this.backGroundOverlay = data["BackGroundOverlay"] !== undefined ? data["BackGroundOverlay"] : <any>null;
      }
  }

  static fromJS(data: any): Background {
      let result = new Background();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["EnableCustomBackgrounds"] = this.enableCustomBackgrounds !== undefined ? this.enableCustomBackgrounds : <any>null;
      data["IntervalBetweenBackgroundsSeconds"] = this.intervalBetweenBackgroundsSeconds !== undefined ? this.intervalBetweenBackgroundsSeconds : <any>null;
      if (this.customBackgroundList && this.customBackgroundList.constructor === Array) {
          data["CustomBackgroundList"] = [];
          for (let item of this.customBackgroundList)
              data["CustomBackgroundList"].push(item.toJSON());
      }
      data["BackGroundOverlay"] = this.backGroundOverlay !== undefined ? this.backGroundOverlay : <any>null;
      return data;
  }
}

export interface IBackground {
  enableCustomBackgrounds?: boolean;
  intervalBetweenBackgroundsSeconds?: number;
  customBackgroundList?: CustomBackground[];
  backGroundOverlay?: boolean;
}

export class CustomBackground implements ICustomBackground {
  name?: string;
  enabled?: boolean;
  uRL?: string;

  constructor(data?: ICustomBackground) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.enabled = data["Enabled"] !== undefined ? data["Enabled"] : <any>null;
          this.uRL = data["URL"] !== undefined ? data["URL"] : <any>null;
      }
  }

  static fromJS(data: any): CustomBackground {
      let result = new CustomBackground();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
      data["URL"] = this.uRL !== undefined ? this.uRL : <any>null;
      return data;
  }
}

export interface ICustomBackground {
  name?: string;
  enabled?: boolean;
  uRL?: string;
}

export class AudioDevices_2_0_0 implements IAudioDevices_2_0_0 {
  bluetooth?: Bluetooth;
  uSB?: USB;
  sIP?: SIP;
  enableKeyClickSounds?: boolean;
  sFB?: SFB_2_0_0;

  constructor(data?: IAudioDevices_2_0_0) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.bluetooth = data["Bluetooth"] ? Bluetooth.fromJS(data["Bluetooth"]) : <any>null;
          this.uSB = data["USB"] ? USB.fromJS(data["USB"]) : <any>null;
          this.sIP = data["SIP"] ? SIP.fromJS(data["SIP"]) : <any>null;
          this.enableKeyClickSounds = data["EnableKeyClickSounds"] !== undefined ? data["EnableKeyClickSounds"] : <any>null;
          this.sFB = data["SFB"] ? SFB_2_0_0.fromJS(data["SFB"]) : <any>null;
      }
  }

  static fromJS(data: any): AudioDevices_2_0_0 {
      let result = new AudioDevices_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Bluetooth"] = this.bluetooth ? this.bluetooth.toJSON() : <any>null;
      data["USB"] = this.uSB ? this.uSB.toJSON() : <any>null;
      data["SIP"] = this.sIP ? this.sIP.toJSON() : <any>null;
      data["EnableKeyClickSounds"] = this.enableKeyClickSounds !== undefined ? this.enableKeyClickSounds : <any>null;
      data["SFB"] = this.sFB ? this.sFB.toJSON() : <any>null;
      return data;
  }
}

export interface IAudioDevices_2_0_0 {
  bluetooth?: Bluetooth;
  uSB?: USB;
  sIP?: SIP;
  enableKeyClickSounds?: boolean;
  sFB?: SFB_2_0_0;
}

export class AudioDevices extends AudioDevices_2_0_0 implements IAudioDevices {
  sFB?: SFB;

  constructor(data?: IAudioDevices) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.sFB = data["SFB"] ? SFB.fromJS(data["SFB"]) : <any>null;
      }
  }

  static fromJS(data: any): AudioDevices {
      let result = new AudioDevices();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["SFB"] = this.sFB ? this.sFB.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IAudioDevices extends IAudioDevices_2_0_0 {
  sFB?: SFB;
}

export class SFB_2_0_0 extends DevicePropertyDocument implements ISFB_2_0_0 {
  enable?: boolean;
  externalServerName?: string;
  internalServerName?: string;
  password?: string;
  presets?: Preset[];
  proxyPassword?: string;
  proxyType?: ProxyType;
  proxyUsername?: string;
  sipAddress?: string;
  username?: string;

  constructor(data?: ISFB_2_0_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.enable = data["Enable"] !== undefined ? data["Enable"] : <any>null;
          this.externalServerName = data["ExternalServerName"] !== undefined ? data["ExternalServerName"] : <any>null;
          this.internalServerName = data["InternalServerName"] !== undefined ? data["InternalServerName"] : <any>null;
          this.password = data["Password"] !== undefined ? data["Password"] : <any>null;
          if (data["Presets"] && data["Presets"].constructor === Array) {
              this.presets = [];
              for (let item of data["Presets"])
                  this.presets.push(Preset.fromJS(item));
          }
          this.proxyPassword = data["ProxyPassword"] !== undefined ? data["ProxyPassword"] : <any>null;
          this.proxyType = data["ProxyType"] !== undefined ? data["ProxyType"] : <any>null;
          this.proxyUsername = data["ProxyUsername"] !== undefined ? data["ProxyUsername"] : <any>null;
          this.sipAddress = data["SipAddress"] !== undefined ? data["SipAddress"] : <any>null;
          this.username = data["Username"] !== undefined ? data["Username"] : <any>null;
      }
  }

  static fromJS(data: any): SFB_2_0_0 {
      let result = new SFB_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Enable"] = this.enable !== undefined ? this.enable : <any>null;
      data["ExternalServerName"] = this.externalServerName !== undefined ? this.externalServerName : <any>null;
      data["InternalServerName"] = this.internalServerName !== undefined ? this.internalServerName : <any>null;
      data["Password"] = this.password !== undefined ? this.password : <any>null;
      if (this.presets && this.presets.constructor === Array) {
          data["Presets"] = [];
          for (let item of this.presets)
              data["Presets"].push(item.toJSON());
      }
      data["ProxyPassword"] = this.proxyPassword !== undefined ? this.proxyPassword : <any>null;
      data["ProxyType"] = this.proxyType !== undefined ? this.proxyType : <any>null;
      data["ProxyUsername"] = this.proxyUsername !== undefined ? this.proxyUsername : <any>null;
      data["SipAddress"] = this.sipAddress !== undefined ? this.sipAddress : <any>null;
      data["Username"] = this.username !== undefined ? this.username : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ISFB_2_0_0 extends IDevicePropertyDocument {
  enable?: boolean;
  externalServerName?: string;
  internalServerName?: string;
  password?: string;
  presets?: Preset[];
  proxyPassword?: string;
  proxyType?: ProxyType;
  proxyUsername?: string;
  sipAddress?: string;
  username?: string;
}

export class SFB extends SFB_2_0_0 implements ISFB {
  displayExtension?: string;

  constructor(data?: ISFB) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.displayExtension = data["DisplayExtension"] !== undefined ? data["DisplayExtension"] : <any>null;
      }
  }

  static fromJS(data: any): SFB {
      let result = new SFB();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DisplayExtension"] = this.displayExtension !== undefined ? this.displayExtension : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ISFB extends ISFB_2_0_0 {
  displayExtension?: string;
}

export class Preset implements IPreset {
  enable?: boolean;
  name?: string;
  number?: string;
  type?: PresetType;

  constructor(data?: IPreset) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enable = data["Enable"] !== undefined ? data["Enable"] : <any>null;
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.number = data["Number"] !== undefined ? data["Number"] : <any>null;
          this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
      }
  }

  static fromJS(data: any): Preset {
      let result = new Preset();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Enable"] = this.enable !== undefined ? this.enable : <any>null;
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Number"] = this.number !== undefined ? this.number : <any>null;
      data["Type"] = this.type !== undefined ? this.type : <any>null;
      return data;
  }
}

export interface IPreset {
  enable?: boolean;
  name?: string;
  number?: string;
  type?: PresetType;
}

export enum PresetType {
  Number = <any>"Number",
  Email = <any>"Email",
  Url = <any>"Url",
}

export enum ProxyType {
  None = <any>"None",
  SameCredentials = <any>"SameCredentials",
  OtherCredentials = <any>"OtherCredentials",
}

export class Bluetooth implements IBluetooth {
  enabled?: boolean;
  friendlyName?: string;
  enableButtons?: boolean;

  constructor(data?: IBluetooth) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enabled = data["Enabled"] !== undefined ? data["Enabled"] : <any>null;
          this.friendlyName = data["FriendlyName"] !== undefined ? data["FriendlyName"] : <any>null;
          this.enableButtons = data["EnableButtons"] !== undefined ? data["EnableButtons"] : <any>null;
      }
  }

  static fromJS(data: any): Bluetooth {
      let result = new Bluetooth();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
      data["FriendlyName"] = this.friendlyName !== undefined ? this.friendlyName : <any>null;
      data["EnableButtons"] = this.enableButtons !== undefined ? this.enableButtons : <any>null;
      return data;
  }
}

export interface IBluetooth {
  enabled?: boolean;
  friendlyName?: string;
  enableButtons?: boolean;
}

export class USB implements IUSB {
  enabled?: boolean;

  constructor(data?: IUSB) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enabled = data["Enabled"] !== undefined ? data["Enabled"] : <any>null;
      }
  }

  static fromJS(data: any): USB {
      let result = new USB();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
      return data;
  }
}

export interface IUSB {
  enabled?: boolean;
}

export class SIP implements ISIP {
  speedKeys?: Speedkey[];
  regexs?: string[];

  constructor(data?: ISIP) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          if (data["SpeedKeys"] && data["SpeedKeys"].constructor === Array) {
              this.speedKeys = [];
              for (let item of data["SpeedKeys"])
                  this.speedKeys.push(Speedkey.fromJS(item));
          }
          if (data["Regexs"] && data["Regexs"].constructor === Array) {
              this.regexs = [];
              for (let item of data["Regexs"])
                  this.regexs.push(item);
          }
      }
  }

  static fromJS(data: any): SIP {
      let result = new SIP();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.speedKeys && this.speedKeys.constructor === Array) {
          data["SpeedKeys"] = [];
          for (let item of this.speedKeys)
              data["SpeedKeys"].push(item.toJSON());
      }
      if (this.regexs && this.regexs.constructor === Array) {
          data["Regexs"] = [];
          for (let item of this.regexs)
              data["Regexs"].push(item);
      }
      return data;
  }
}

export interface ISIP {
  speedKeys?: Speedkey[];
  regexs?: string[];
}

export class Speedkey implements ISpeedkey {
  enabled?: boolean;
  name?: string;
  number?: string;

  constructor(data?: ISpeedkey) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enabled = data["Enabled"] !== undefined ? data["Enabled"] : <any>null;
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.number = data["Number"] !== undefined ? data["Number"] : <any>null;
      }
  }

  static fromJS(data: any): Speedkey {
      let result = new Speedkey();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["Number"] = this.number !== undefined ? this.number : <any>null;
      return data;
  }
}

export interface ISpeedkey {
  enabled?: boolean;
  name?: string;
  number?: string;
}

export class TimeOptions implements ITimeOptions {
  timeFormat?: string;
  dateFormat?: string;

  constructor(data?: ITimeOptions) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.timeFormat = data["TimeFormat"] !== undefined ? data["TimeFormat"] : <any>null;
          this.dateFormat = data["DateFormat"] !== undefined ? data["DateFormat"] : <any>null;
      }
  }

  static fromJS(data: any): TimeOptions {
      let result = new TimeOptions();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["TimeFormat"] = this.timeFormat !== undefined ? this.timeFormat : <any>null;
      data["DateFormat"] = this.dateFormat !== undefined ? this.dateFormat : <any>null;
      return data;
  }
}

export interface ITimeOptions {
  timeFormat?: string;
  dateFormat?: string;
}

export class FusionSetup implements IFusionSetup {
  fusionEnabled?: boolean;
  roomName?: string;
  enableTLS?: boolean;
  port?: number;
  ipId?: number;
  cloudUrlEnabled?: boolean;
  cloudUrl?: string;
  iPHostName?: string;

  constructor(data?: IFusionSetup) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.fusionEnabled = data["FusionEnabled"] !== undefined ? data["FusionEnabled"] : <any>null;
          this.roomName = data["RoomName"] !== undefined ? data["RoomName"] : <any>null;
          this.enableTLS = data["EnableTLS"] !== undefined ? data["EnableTLS"] : <any>null;
          this.port = data["Port"] !== undefined ? data["Port"] : <any>null;
          this.ipId = data["IpId"] !== undefined ? data["IpId"] : <any>null;
          this.cloudUrlEnabled = data["CloudUrlEnabled"] !== undefined ? data["CloudUrlEnabled"] : <any>null;
          this.cloudUrl = data["CloudUrl"] !== undefined ? data["CloudUrl"] : <any>null;
          this.iPHostName = data["IPHostName"] !== undefined ? data["IPHostName"] : <any>null;
      }
  }

  static fromJS(data: any): FusionSetup {
      let result = new FusionSetup();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["FusionEnabled"] = this.fusionEnabled !== undefined ? this.fusionEnabled : <any>null;
      data["RoomName"] = this.roomName !== undefined ? this.roomName : <any>null;
      data["EnableTLS"] = this.enableTLS !== undefined ? this.enableTLS : <any>null;
      data["Port"] = this.port !== undefined ? this.port : <any>null;
      data["IpId"] = this.ipId !== undefined ? this.ipId : <any>null;
      data["CloudUrlEnabled"] = this.cloudUrlEnabled !== undefined ? this.cloudUrlEnabled : <any>null;
      data["CloudUrl"] = this.cloudUrl !== undefined ? this.cloudUrl : <any>null;
      data["IPHostName"] = this.iPHostName !== undefined ? this.iPHostName : <any>null;
      return data;
  }
}

export interface IFusionSetup {
  fusionEnabled?: boolean;
  roomName?: string;
  enableTLS?: boolean;
  port?: number;
  ipId?: number;
  cloudUrlEnabled?: boolean;
  cloudUrl?: string;
  iPHostName?: string;
}

export class Scheduling implements IScheduling {
  enable?: boolean;
  source?: string;
  exchangeEwsUrl?: string;
  domain?: string;
  username?: string;
  password?: string;
  calendarEmailAddress?: string;

  constructor(data?: IScheduling) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.enable = data["Enable"] !== undefined ? data["Enable"] : <any>null;
          this.source = data["Source"] !== undefined ? data["Source"] : <any>null;
          this.exchangeEwsUrl = data["ExchangeEwsUrl"] !== undefined ? data["ExchangeEwsUrl"] : <any>null;
          this.domain = data["Domain"] !== undefined ? data["Domain"] : <any>null;
          this.username = data["Username"] !== undefined ? data["Username"] : <any>null;
          this.password = data["Password"] !== undefined ? data["Password"] : <any>null;
          this.calendarEmailAddress = data["CalendarEmailAddress"] !== undefined ? data["CalendarEmailAddress"] : <any>null;
      }
  }

  static fromJS(data: any): Scheduling {
      let result = new Scheduling();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Enable"] = this.enable !== undefined ? this.enable : <any>null;
      data["Source"] = this.source !== undefined ? this.source : <any>null;
      data["ExchangeEwsUrl"] = this.exchangeEwsUrl !== undefined ? this.exchangeEwsUrl : <any>null;
      data["Domain"] = this.domain !== undefined ? this.domain : <any>null;
      data["Username"] = this.username !== undefined ? this.username : <any>null;
      data["Password"] = this.password !== undefined ? this.password : <any>null;
      data["CalendarEmailAddress"] = this.calendarEmailAddress !== undefined ? this.calendarEmailAddress : <any>null;
      return data;
  }
}

export interface IScheduling {
  enable?: boolean;
  source?: string;
  exchangeEwsUrl?: string;
  domain?: string;
  username?: string;
  password?: string;
  calendarEmailAddress?: string;
}

export class VideoDisplay implements IVideoDisplay {
  driverId?: string;
  displayName?: string;
  ipId?: number;
  channel?: number;
  ipAddress?: string;
  baudRate?: number;
  ipPort?: number;
  model?: string;
  control?: string;
  defaultInput?: string;

  constructor(data?: IVideoDisplay) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.driverId = data["DriverId"] !== undefined ? data["DriverId"] : <any>null;
          this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : <any>null;
          this.ipId = data["IpId"] !== undefined ? data["IpId"] : <any>null;
          this.channel = data["Channel"] !== undefined ? data["Channel"] : <any>null;
          this.ipAddress = data["IpAddress"] !== undefined ? data["IpAddress"] : <any>null;
          this.baudRate = data["BaudRate"] !== undefined ? data["BaudRate"] : <any>null;
          this.ipPort = data["IpPort"] !== undefined ? data["IpPort"] : <any>null;
          this.model = data["Model"] !== undefined ? data["Model"] : <any>null;
          this.control = data["Control"] !== undefined ? data["Control"] : <any>null;
          this.defaultInput = data["DefaultInput"] !== undefined ? data["DefaultInput"] : <any>null;
      }
  }

  static fromJS(data: any): VideoDisplay {
      let result = new VideoDisplay();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DriverId"] = this.driverId !== undefined ? this.driverId : <any>null;
      data["DisplayName"] = this.displayName !== undefined ? this.displayName : <any>null;
      data["IpId"] = this.ipId !== undefined ? this.ipId : <any>null;
      data["Channel"] = this.channel !== undefined ? this.channel : <any>null;
      data["IpAddress"] = this.ipAddress !== undefined ? this.ipAddress : <any>null;
      data["BaudRate"] = this.baudRate !== undefined ? this.baudRate : <any>null;
      data["IpPort"] = this.ipPort !== undefined ? this.ipPort : <any>null;
      data["Model"] = this.model !== undefined ? this.model : <any>null;
      data["Control"] = this.control !== undefined ? this.control : <any>null;
      data["DefaultInput"] = this.defaultInput !== undefined ? this.defaultInput : <any>null;
      return data;
  }
}

export interface IVideoDisplay {
  driverId?: string;
  displayName?: string;
  ipId?: number;
  channel?: number;
  ipAddress?: string;
  baudRate?: number;
  ipPort?: number;
  model?: string;
  control?: string;
  defaultInput?: string;
}

export class RunTime implements IRunTime {
  callStatus?: string;
  routedInput?: string;
  occupancyStatus?: string;
  bluetoothConnectionStatus?: string;
  usbConnectionStatus?: string;
  fusionStatus?: string;
  fusionConnectionType?: string;
  calendarConnectionStatus?: string;
  displayPowerStatus?: string;
  mute?: boolean;
  micMute?: boolean;
  volume?: number;
  sleepStatus?: string;
  skypeConnection?: string;
  skypePresence?: string;

  constructor(data?: IRunTime) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.callStatus = data["CallStatus"] !== undefined ? data["CallStatus"] : <any>null;
          this.routedInput = data["RoutedInput"] !== undefined ? data["RoutedInput"] : <any>null;
          this.occupancyStatus = data["OccupancyStatus"] !== undefined ? data["OccupancyStatus"] : <any>null;
          this.bluetoothConnectionStatus = data["BluetoothConnectionStatus"] !== undefined ? data["BluetoothConnectionStatus"] : <any>null;
          this.usbConnectionStatus = data["UsbConnectionStatus"] !== undefined ? data["UsbConnectionStatus"] : <any>null;
          this.fusionStatus = data["FusionStatus"] !== undefined ? data["FusionStatus"] : <any>null;
          this.fusionConnectionType = data["FusionConnectionType"] !== undefined ? data["FusionConnectionType"] : <any>null;
          this.calendarConnectionStatus = data["CalendarConnectionStatus"] !== undefined ? data["CalendarConnectionStatus"] : <any>null;
          this.displayPowerStatus = data["DisplayPowerStatus"] !== undefined ? data["DisplayPowerStatus"] : <any>null;
          this.mute = data["Mute"] !== undefined ? data["Mute"] : <any>null;
          this.micMute = data["MicMute"] !== undefined ? data["MicMute"] : <any>null;
          this.volume = data["Volume"] !== undefined ? data["Volume"] : <any>null;
          this.sleepStatus = data["SleepStatus"] !== undefined ? data["SleepStatus"] : <any>null;
          this.skypeConnection = data["SkypeConnection"] !== undefined ? data["SkypeConnection"] : <any>null;
          this.skypePresence = data["SkypePresence"] !== undefined ? data["SkypePresence"] : <any>null;
      }
  }

  static fromJS(data: any): RunTime {
      let result = new RunTime();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["CallStatus"] = this.callStatus !== undefined ? this.callStatus : <any>null;
      data["RoutedInput"] = this.routedInput !== undefined ? this.routedInput : <any>null;
      data["OccupancyStatus"] = this.occupancyStatus !== undefined ? this.occupancyStatus : <any>null;
      data["BluetoothConnectionStatus"] = this.bluetoothConnectionStatus !== undefined ? this.bluetoothConnectionStatus : <any>null;
      data["UsbConnectionStatus"] = this.usbConnectionStatus !== undefined ? this.usbConnectionStatus : <any>null;
      data["FusionStatus"] = this.fusionStatus !== undefined ? this.fusionStatus : <any>null;
      data["FusionConnectionType"] = this.fusionConnectionType !== undefined ? this.fusionConnectionType : <any>null;
      data["CalendarConnectionStatus"] = this.calendarConnectionStatus !== undefined ? this.calendarConnectionStatus : <any>null;
      data["DisplayPowerStatus"] = this.displayPowerStatus !== undefined ? this.displayPowerStatus : <any>null;
      data["Mute"] = this.mute !== undefined ? this.mute : <any>null;
      data["MicMute"] = this.micMute !== undefined ? this.micMute : <any>null;
      data["Volume"] = this.volume !== undefined ? this.volume : <any>null;
      data["SleepStatus"] = this.sleepStatus !== undefined ? this.sleepStatus : <any>null;
      data["SkypeConnection"] = this.skypeConnection !== undefined ? this.skypeConnection : <any>null;
      data["SkypePresence"] = this.skypePresence !== undefined ? this.skypePresence : <any>null;
      return data;
  }
}

export interface IRunTime {
  callStatus?: string;
  routedInput?: string;
  occupancyStatus?: string;
  bluetoothConnectionStatus?: string;
  usbConnectionStatus?: string;
  fusionStatus?: string;
  fusionConnectionType?: string;
  calendarConnectionStatus?: string;
  displayPowerStatus?: string;
  mute?: boolean;
  micMute?: boolean;
  volume?: number;
  sleepStatus?: string;
  skypeConnection?: string;
  skypePresence?: string;
}

export class ThirdPartyApplications_2_0_0 extends DevicePropertyDocument implements IThirdPartyApplications_2_0_0 {
  zoomRoom?: ZoomRoom;

  constructor(data?: IThirdPartyApplications_2_0_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.zoomRoom = data["ZoomRoom"] ? ZoomRoom.fromJS(data["ZoomRoom"]) : <any>null;
      }
  }

  static fromJS(data: any): ThirdPartyApplications_2_0_0 {
      let result = new ThirdPartyApplications_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["ZoomRoom"] = this.zoomRoom ? this.zoomRoom.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IThirdPartyApplications_2_0_0 extends IDevicePropertyDocument {
  zoomRoom?: ZoomRoom;
}

export class ThirdPartyApplications_2_1_0 extends ThirdPartyApplications_2_0_0 implements IThirdPartyApplications_2_1_0 {
  appSpace?: AppSpace;

  constructor(data?: IThirdPartyApplications_2_1_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.appSpace = data["AppSpace"] ? AppSpace.fromJS(data["AppSpace"]) : <any>null;
      }
  }

  static fromJS(data: any): ThirdPartyApplications_2_1_0 {
      let result = new ThirdPartyApplications_2_1_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["AppSpace"] = this.appSpace ? this.appSpace.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IThirdPartyApplications_2_1_0 extends IThirdPartyApplications_2_0_0 {
  appSpace?: AppSpace;
}

export class ThirdPartyApplications_2_2_0 extends ThirdPartyApplications_2_1_0 implements IThirdPartyApplications_2_2_0 {
  mode?: Mode;
  settings?: Settings2;

  constructor(data?: IThirdPartyApplications_2_2_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.mode = data["Mode"] !== undefined ? data["Mode"] : <any>null;
          this.settings = data["Settings"] ? Settings2.fromJS(data["Settings"]) : <any>null;
      }
  }

  static fromJS(data: any): ThirdPartyApplications_2_2_0 {
      let result = new ThirdPartyApplications_2_2_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Mode"] = this.mode !== undefined ? this.mode : <any>null;
      data["Settings"] = this.settings ? this.settings.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IThirdPartyApplications_2_2_0 extends IThirdPartyApplications_2_1_0 {
  mode?: Mode;
  settings?: Settings2;
}

export class ThirdPartyApplications_2_2_1 extends ThirdPartyApplications_2_2_0 implements IThirdPartyApplications_2_2_1 {
  skypeRoom?: SkypeRoom;

  constructor(data?: IThirdPartyApplications_2_2_1) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.skypeRoom = data["SkypeRoom"] ? SkypeRoom.fromJS(data["SkypeRoom"]) : <any>null;
      }
  }

  static fromJS(data: any): ThirdPartyApplications_2_2_1 {
      let result = new ThirdPartyApplications_2_2_1();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["SkypeRoom"] = this.skypeRoom ? this.skypeRoom.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IThirdPartyApplications_2_2_1 extends IThirdPartyApplications_2_2_0 {
  skypeRoom?: SkypeRoom;
}

export class ThirdPartyApplications extends ThirdPartyApplications_2_2_1 implements IThirdPartyApplications {
  ems?: Ems;

  constructor(data?: IThirdPartyApplications) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.ems = data["Ems"] ? Ems.fromJS(data["Ems"]) : <any>null;
      }
  }

  static fromJS(data: any): ThirdPartyApplications {
      let result = new ThirdPartyApplications();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Ems"] = this.ems ? this.ems.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IThirdPartyApplications extends IThirdPartyApplications_2_2_1 {
  ems?: Ems;
}

export class Ems implements IEms {
  serverUrl?: string;

  constructor(data?: IEms) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.serverUrl = data["ServerUrl"] !== undefined ? data["ServerUrl"] : <any>null;
      }
  }

  static fromJS(data: any): Ems {
      let result = new Ems();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["ServerUrl"] = this.serverUrl !== undefined ? this.serverUrl : <any>null;
      return data;
  }
}

export interface IEms {
  serverUrl?: string;
}

export class SkypeRoom implements ISkypeRoom {
  skypeRoomPcAddress?: string;
  skypeRoomPcPort?: number;
  skypeRoomPcUsername?: string;
  skypeRoomPcPassword?: string;

  constructor(data?: ISkypeRoom) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.skypeRoomPcAddress = data["SkypeRoomPcAddress"] !== undefined ? data["SkypeRoomPcAddress"] : <any>null;
          this.skypeRoomPcPort = data["SkypeRoomPcPort"] !== undefined ? data["SkypeRoomPcPort"] : <any>null;
          this.skypeRoomPcUsername = data["SkypeRoomPcUsername"] !== undefined ? data["SkypeRoomPcUsername"] : <any>null;
          this.skypeRoomPcPassword = data["SkypeRoomPcPassword"] !== undefined ? data["SkypeRoomPcPassword"] : <any>null;
      }
  }

  static fromJS(data: any): SkypeRoom {
      let result = new SkypeRoom();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["SkypeRoomPcAddress"] = this.skypeRoomPcAddress !== undefined ? this.skypeRoomPcAddress : <any>null;
      data["SkypeRoomPcPort"] = this.skypeRoomPcPort !== undefined ? this.skypeRoomPcPort : <any>null;
      data["SkypeRoomPcUsername"] = this.skypeRoomPcUsername !== undefined ? this.skypeRoomPcUsername : <any>null;
      data["SkypeRoomPcPassword"] = this.skypeRoomPcPassword !== undefined ? this.skypeRoomPcPassword : <any>null;
      return data;
  }
}

export interface ISkypeRoom {
  skypeRoomPcAddress?: string;
  skypeRoomPcPort?: number;
  skypeRoomPcUsername?: string;
  skypeRoomPcPassword?: string;
}

export enum Mode {
  User = <any>"User",
  OOTB = <any>"OOTB",
  ZoomRoom = <any>"ZoomRoom",
  Appspace = <any>"Appspace",
  Teem = <any>"Teem",
  Robin = <any>"Robin",
  EMS = <any>"EMS",
  SkypeRoom = <any>"SkypeRoom",
}

export class Settings2 implements ISettings2 {
  pageFlip?: boolean;
  timeOutMode?: TimeoutMode;
  timeoutInMinutes?: number;

  constructor(data?: ISettings2) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.pageFlip = data["PageFlip"] !== undefined ? data["PageFlip"] : <any>null;
          this.timeOutMode = data["TimeOutMode"] !== undefined ? data["TimeOutMode"] : <any>null;
          this.timeoutInMinutes = data["TimeoutInMinutes"] !== undefined ? data["TimeoutInMinutes"] : <any>null;
      }
  }

  static fromJS(data: any): Settings2 {
      let result = new Settings2();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["PageFlip"] = this.pageFlip !== undefined ? this.pageFlip : <any>null;
      data["TimeOutMode"] = this.timeOutMode !== undefined ? this.timeOutMode : <any>null;
      data["TimeoutInMinutes"] = this.timeoutInMinutes !== undefined ? this.timeoutInMinutes : <any>null;
      return data;
  }
}

export interface ISettings2 {
  pageFlip?: boolean;
  timeOutMode?: TimeoutMode;
  timeoutInMinutes?: number;
}

export enum TimeoutMode {
  Disabled = <any>"Disabled",
  FlipToProject = <any>"FlipToProject",
  FlipToMode = <any>"FlipToMode",
}

export class AppSpace implements IAppSpace {
  isEnabled?: boolean;
  accountLocation?: AccountLocation;
  serverUrl?: string;
  isSignageInStandbyEnabled?: boolean;
  isSignageAsBackgroundEnabled?: boolean;

  constructor(data?: IAppSpace) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.accountLocation = data["AccountLocation"] !== undefined ? data["AccountLocation"] : <any>null;
          this.serverUrl = data["ServerUrl"] !== undefined ? data["ServerUrl"] : <any>null;
          this.isSignageInStandbyEnabled = data["IsSignageInStandbyEnabled"] !== undefined ? data["IsSignageInStandbyEnabled"] : <any>null;
          this.isSignageAsBackgroundEnabled = data["IsSignageAsBackgroundEnabled"] !== undefined ? data["IsSignageAsBackgroundEnabled"] : <any>null;
      }
  }

  static fromJS(data: any): AppSpace {
      let result = new AppSpace();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["AccountLocation"] = this.accountLocation !== undefined ? this.accountLocation : <any>null;
      data["ServerUrl"] = this.serverUrl !== undefined ? this.serverUrl : <any>null;
      data["IsSignageInStandbyEnabled"] = this.isSignageInStandbyEnabled !== undefined ? this.isSignageInStandbyEnabled : <any>null;
      data["IsSignageAsBackgroundEnabled"] = this.isSignageAsBackgroundEnabled !== undefined ? this.isSignageAsBackgroundEnabled : <any>null;
      return data;
  }
}

export interface IAppSpace {
  isEnabled?: boolean;
  accountLocation?: AccountLocation;
  serverUrl?: string;
  isSignageInStandbyEnabled?: boolean;
  isSignageAsBackgroundEnabled?: boolean;
}

export enum AccountLocation {
  PublicCloud = <any>"PublicCloud",
  PrivateInstance = <any>"PrivateInstance",
}

export class ZoomRoom extends ObjectVersion implements IZoomRoom {
  isEnabled?: boolean;

  constructor(data?: IZoomRoom) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
      }
  }

  static fromJS(data: any): ZoomRoom {
      let result = new ZoomRoom();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IZoomRoom extends IObjectVersion {
  isEnabled?: boolean;
}

export class CloudSettings extends DevicePropertyDocument implements ICloudSettings {
  fusionCloud?: FusionCloud2;

  constructor(data?: ICloudSettings) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.fusionCloud = data["FusionCloud"] ? FusionCloud2.fromJS(data["FusionCloud"]) : <any>null;
      }
  }

  static fromJS(data: any): CloudSettings {
      let result = new CloudSettings();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["FusionCloud"] = this.fusionCloud ? this.fusionCloud.toJSON() : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface ICloudSettings extends IDevicePropertyDocument {
  fusionCloud?: FusionCloud2;
}

export class FusionCloud2 implements IFusionCloud2 {
  isEnabled?: boolean;
  url?: string;

  constructor(data?: IFusionCloud2) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.url = data["Url"] !== undefined ? data["Url"] : <any>null;
      }
  }

  static fromJS(data: any): FusionCloud2 {
      let result = new FusionCloud2();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["Url"] = this.url !== undefined ? this.url : <any>null;
      return data;
  }
}

export interface IFusionCloud2 {
  isEnabled?: boolean;
  url?: string;
}

export class Display implements IDisplay {
  language?: string;

  constructor(data?: IDisplay) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.language = data["Language"] !== undefined ? data["Language"] : <any>null;
      }
  }

  static fromJS(data: any): Display {
      let result = new Display();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Language"] = this.language !== undefined ? this.language : <any>null;
      return data;
  }
}

export interface IDisplay {
  language?: string;
}

export class DeviceInfo implements IDeviceInfo {
  model?: string;
  category?: string;
  manufacturer?: string;
  deviceId?: string;
  serialNumber?: string;
  name?: string;
  deviceVersion?: string;
  buildDate?: string;
  deviceKey?: string;

  constructor(data?: IDeviceInfo) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.model = data["Model"] !== undefined ? data["Model"] : <any>null;
          this.category = data["Category"] !== undefined ? data["Category"] : <any>null;
          this.manufacturer = data["Manufacturer"] !== undefined ? data["Manufacturer"] : <any>null;
          this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : <any>null;
          this.serialNumber = data["SerialNumber"] !== undefined ? data["SerialNumber"] : <any>null;
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.deviceVersion = data["DeviceVersion"] !== undefined ? data["DeviceVersion"] : <any>null;
          this.buildDate = data["BuildDate"] !== undefined ? data["BuildDate"] : <any>null;
          this.deviceKey = data["DeviceKey"] !== undefined ? data["DeviceKey"] : <any>null;
      }
  }

  static fromJS(data: any): DeviceInfo {
      let result = new DeviceInfo();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Model"] = this.model !== undefined ? this.model : <any>null;
      data["Category"] = this.category !== undefined ? this.category : <any>null;
      data["Manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
      data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
      data["SerialNumber"] = this.serialNumber !== undefined ? this.serialNumber : <any>null;
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["DeviceVersion"] = this.deviceVersion !== undefined ? this.deviceVersion : <any>null;
      data["BuildDate"] = this.buildDate !== undefined ? this.buildDate : <any>null;
      data["DeviceKey"] = this.deviceKey !== undefined ? this.deviceKey : <any>null;
      return data;
  }
}

export interface IDeviceInfo {
  model?: string;
  category?: string;
  manufacturer?: string;
  deviceId?: string;
  serialNumber?: string;
  name?: string;
  deviceVersion?: string;
  buildDate?: string;
  deviceKey?: string;
}

export class MergeAction extends ObjectVersion implements IMergeAction {
  deliveryState?: DeliveryStateEnum;
  operations?: DeviceOperation[];
  message?: string;

  constructor(data?: IMergeAction) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.deliveryState = data["DeliveryState"] !== undefined ? data["DeliveryState"] : <any>null;
          if (data["Operations"] && data["Operations"].constructor === Array) {
              this.operations = [];
              for (let item of data["Operations"])
                  this.operations.push(DeviceOperation.fromJS(item));
          }
          this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
      }
  }

  static fromJS(data: any): MergeAction {
      let result = new MergeAction();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["DeliveryState"] = this.deliveryState !== undefined ? this.deliveryState : <any>null;
      if (this.operations && this.operations.constructor === Array) {
          data["Operations"] = [];
          for (let item of this.operations)
              data["Operations"].push(item.toJSON());
      }
      data["Message"] = this.message !== undefined ? this.message : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IMergeAction extends IObjectVersion {
  deliveryState?: DeliveryStateEnum;
  operations?: DeviceOperation[];
  message?: string;
}

export enum DeliveryStateEnum {
  NA = <any>"NA",
  Pending = <any>"Pending",
  Delivered = <any>"Delivered",
  OnHold = <any>"OnHold",
  Blocked = <any>"Blocked",
}

export class DeviceOperation implements IDeviceOperation {
  targetObject?: string;
  deliveryState?: DeliveryStateEnum;
  operation?: OperationEnum;
  results?: Result[];

  constructor(data?: IDeviceOperation) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
          this.deliveryState = data["DeliveryState"] !== undefined ? data["DeliveryState"] : <any>null;
          this.operation = data["Operation"] !== undefined ? data["Operation"] : <any>null;
          if (data["Results"] && data["Results"].constructor === Array) {
              this.results = [];
              for (let item of data["Results"])
                  this.results.push(Result.fromJS(item));
          }
      }
  }

  static fromJS(data: any): DeviceOperation {
      let result = new DeviceOperation();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
      data["DeliveryState"] = this.deliveryState !== undefined ? this.deliveryState : <any>null;
      data["Operation"] = this.operation !== undefined ? this.operation : <any>null;
      if (this.results && this.results.constructor === Array) {
          data["Results"] = [];
          for (let item of this.results)
              data["Results"].push(item.toJSON());
      }
      return data;
  }
}

export interface IDeviceOperation {
  targetObject?: string;
  deliveryState?: DeliveryStateEnum;
  operation?: OperationEnum;
  results?: Result[];
}

export enum OperationEnum {
  NA = <any>"NA",
  SetPartial = <any>"SetPartial",
  SetFull = <any>"SetFull",
}

export class Result implements IResult {
  operationState?: OperationStateEnum;
  property?: string;
  path?: string;
  statusId?: number;
  statusInfo?: string;

  constructor(data?: IResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.operationState = data["OperationState"] !== undefined ? data["OperationState"] : <any>null;
          this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
          this.path = data["Path"] !== undefined ? data["Path"] : <any>null;
          this.statusId = data["StatusId"] !== undefined ? data["StatusId"] : <any>null;
          this.statusInfo = data["StatusInfo"] !== undefined ? data["StatusInfo"] : <any>null;
      }
  }

  static fromJS(data: any): Result {
      let result = new Result();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["OperationState"] = this.operationState !== undefined ? this.operationState : <any>null;
      data["Property"] = this.property !== undefined ? this.property : <any>null;
      data["Path"] = this.path !== undefined ? this.path : <any>null;
      data["StatusId"] = this.statusId !== undefined ? this.statusId : <any>null;
      data["StatusInfo"] = this.statusInfo !== undefined ? this.statusInfo : <any>null;
      return data;
  }
}

export interface IResult {
  operationState?: OperationStateEnum;
  property?: string;
  path?: string;
  statusId?: number;
  statusInfo?: string;
}

export enum OperationStateEnum {
  NA = <any>"NA",
  Rejected = <any>"Rejected",
  Applied = <any>"Applied",
}

export class Ethernet_2_0_0 extends ObjectVersion implements IEthernet_2_0_0 {
  isEnabled?: boolean;
  autoNegotiationEnabled?: boolean;
  isIcmpPingEnabled?: boolean;
  isTcpKeepAliveEnabled?: boolean;
  hostName?: string;
  domainName?: string;
  encryptConnection?: boolean;
  adapters?: Adapter[];

  constructor(data?: IEthernet_2_0_0) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          this.autoNegotiationEnabled = data["AutoNegotiationEnabled"] !== undefined ? data["AutoNegotiationEnabled"] : <any>null;
          this.isIcmpPingEnabled = data["IsIcmpPingEnabled"] !== undefined ? data["IsIcmpPingEnabled"] : <any>null;
          this.isTcpKeepAliveEnabled = data["IsTcpKeepAliveEnabled"] !== undefined ? data["IsTcpKeepAliveEnabled"] : <any>null;
          this.hostName = data["HostName"] !== undefined ? data["HostName"] : <any>null;
          this.domainName = data["DomainName"] !== undefined ? data["DomainName"] : <any>null;
          this.encryptConnection = data["EncryptConnection"] !== undefined ? data["EncryptConnection"] : <any>null;
          if (data["Adapters"] && data["Adapters"].constructor === Array) {
              this.adapters = [];
              for (let item of data["Adapters"])
                  this.adapters.push(Adapter.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Ethernet_2_0_0 {
      let result = new Ethernet_2_0_0();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      data["AutoNegotiationEnabled"] = this.autoNegotiationEnabled !== undefined ? this.autoNegotiationEnabled : <any>null;
      data["IsIcmpPingEnabled"] = this.isIcmpPingEnabled !== undefined ? this.isIcmpPingEnabled : <any>null;
      data["IsTcpKeepAliveEnabled"] = this.isTcpKeepAliveEnabled !== undefined ? this.isTcpKeepAliveEnabled : <any>null;
      data["HostName"] = this.hostName !== undefined ? this.hostName : <any>null;
      data["DomainName"] = this.domainName !== undefined ? this.domainName : <any>null;
      data["EncryptConnection"] = this.encryptConnection !== undefined ? this.encryptConnection : <any>null;
      if (this.adapters && this.adapters.constructor === Array) {
          data["Adapters"] = [];
          for (let item of this.adapters)
              data["Adapters"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IEthernet_2_0_0 extends IObjectVersion {
  isEnabled?: boolean;
  autoNegotiationEnabled?: boolean;
  isIcmpPingEnabled?: boolean;
  isTcpKeepAliveEnabled?: boolean;
  hostName?: string;
  domainName?: string;
  encryptConnection?: boolean;
  adapters?: Adapter[];
}

export class Ethernet_2_0_1 extends Ethernet_2_0_0 implements IEthernet_2_0_1 {
  isSshEnabled?: boolean;

  constructor(data?: IEthernet_2_0_1) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.isSshEnabled = data["IsSshEnabled"] !== undefined ? data["IsSshEnabled"] : <any>null;
      }
  }

  static fromJS(data: any): Ethernet_2_0_1 {
      let result = new Ethernet_2_0_1();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IsSshEnabled"] = this.isSshEnabled !== undefined ? this.isSshEnabled : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IEthernet_2_0_1 extends IEthernet_2_0_0 {
  isSshEnabled?: boolean;
}

export class Ethernet_2_0_2 extends Ethernet_2_0_1 implements IEthernet_2_0_2 {
  igmpVersion?: string;

  constructor(data?: IEthernet_2_0_2) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
          this.igmpVersion = data["IgmpVersion"] !== undefined ? data["IgmpVersion"] : <any>null;
      }
  }

  static fromJS(data: any): Ethernet_2_0_2 {
      let result = new Ethernet_2_0_2();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["IgmpVersion"] = this.igmpVersion !== undefined ? this.igmpVersion : <any>null;
      super.toJSON(data);
      return data;
  }
}

export interface IEthernet_2_0_2 extends IEthernet_2_0_1 {
  igmpVersion?: string;
}

export class Ethernet_2_0_3 extends Ethernet_2_0_2 implements IEthernet_2_0_3 {

  constructor(data?: IEthernet_2_0_3) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
      }
  }

  static fromJS(data: any): Ethernet_2_0_3 {
      let result = new Ethernet_2_0_3();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IEthernet_2_0_3 extends IEthernet_2_0_2 {
}

export class Ethernet extends Ethernet_2_0_3 implements IEthernet {

  constructor(data?: IEthernet) {
      super(data);
  }

  init(data?: any) {
      super.init(data);
      if (data) {
      }
  }

  static fromJS(data: any): Ethernet {
      let result = new Ethernet();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IEthernet extends IEthernet_2_0_3 {
}

export class Adapter implements IAdapter {
  name?: string;
  mACAddress?: string;
  addressSchema?: string;
  isAdapterEnabled?: boolean;
  linkStatus?: boolean;
  portAssignments?: PortAssigment[];
  iPv4?: IPAddr;
  iPv6?: IPAddr;

  constructor(data?: IAdapter) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.mACAddress = data["MACAddress"] !== undefined ? data["MACAddress"] : <any>null;
          this.addressSchema = data["AddressSchema"] !== undefined ? data["AddressSchema"] : <any>null;
          this.isAdapterEnabled = data["IsAdapterEnabled"] !== undefined ? data["IsAdapterEnabled"] : <any>null;
          this.linkStatus = data["LinkStatus"] !== undefined ? data["LinkStatus"] : <any>null;
          if (data["PortAssignments"] && data["PortAssignments"].constructor === Array) {
              this.portAssignments = [];
              for (let item of data["PortAssignments"])
                  this.portAssignments.push(PortAssigment.fromJS(item));
          }
          this.iPv4 = data["IPv4"] ? IPAddr.fromJS(data["IPv4"]) : <any>null;
          this.iPv6 = data["IPv6"] ? IPAddr.fromJS(data["IPv6"]) : <any>null;
      }
  }

  static fromJS(data: any): Adapter {
      let result = new Adapter();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["MACAddress"] = this.mACAddress !== undefined ? this.mACAddress : <any>null;
      data["AddressSchema"] = this.addressSchema !== undefined ? this.addressSchema : <any>null;
      data["IsAdapterEnabled"] = this.isAdapterEnabled !== undefined ? this.isAdapterEnabled : <any>null;
      data["LinkStatus"] = this.linkStatus !== undefined ? this.linkStatus : <any>null;
      if (this.portAssignments && this.portAssignments.constructor === Array) {
          data["PortAssignments"] = [];
          for (let item of this.portAssignments)
              data["PortAssignments"].push(item.toJSON());
      }
      data["IPv4"] = this.iPv4 ? this.iPv4.toJSON() : <any>null;
      data["IPv6"] = this.iPv6 ? this.iPv6.toJSON() : <any>null;
      return data;
  }
}

export interface IAdapter {
  name?: string;
  mACAddress?: string;
  addressSchema?: string;
  isAdapterEnabled?: boolean;
  linkStatus?: boolean;
  portAssignments?: PortAssigment[];
  iPv4?: IPAddr;
  iPv6?: IPAddr;
}

export class PortAssigment implements IPortAssigment {
  name?: string;
  isEnabled?: boolean;
  portNumbers?: number[];

  constructor(data?: IPortAssigment) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.name = data["Name"] !== undefined ? data["Name"] : <any>null;
          this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
          if (data["PortNumbers"] && data["PortNumbers"].constructor === Array) {
              this.portNumbers = [];
              for (let item of data["PortNumbers"])
                  this.portNumbers.push(item);
          }
      }
  }

  static fromJS(data: any): PortAssigment {
      let result = new PortAssigment();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Name"] = this.name !== undefined ? this.name : <any>null;
      data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
      if (this.portNumbers && this.portNumbers.constructor === Array) {
          data["PortNumbers"] = [];
          for (let item of this.portNumbers)
              data["PortNumbers"].push(item);
      }
      return data;
  }
}

export interface IPortAssigment {
  name?: string;
  isEnabled?: boolean;
  portNumbers?: number[];
}

export class IPAddr implements IIPAddr {
  addresses?: Addresses[];
  staticAddresses?: Addresses[];
  staticDefaultGateway?: string;
  defaultGateway?: string;
  dnsServers?: string[];
  staticDns?: string[];
  isDhcpEnabled?: boolean;

  constructor(data?: IIPAddr) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          if (data["Addresses"] && data["Addresses"].constructor === Array) {
              this.addresses = [];
              for (let item of data["Addresses"])
                  this.addresses.push(Addresses.fromJS(item));
          }
          if (data["StaticAddresses"] && data["StaticAddresses"].constructor === Array) {
              this.staticAddresses = [];
              for (let item of data["StaticAddresses"])
                  this.staticAddresses.push(Addresses.fromJS(item));
          }
          this.staticDefaultGateway = data["StaticDefaultGateway"] !== undefined ? data["StaticDefaultGateway"] : <any>null;
          this.defaultGateway = data["DefaultGateway"] !== undefined ? data["DefaultGateway"] : <any>null;
          if (data["DnsServers"] && data["DnsServers"].constructor === Array) {
              this.dnsServers = [];
              for (let item of data["DnsServers"])
                  this.dnsServers.push(item);
          }
          if (data["StaticDns"] && data["StaticDns"].constructor === Array) {
              this.staticDns = [];
              for (let item of data["StaticDns"])
                  this.staticDns.push(item);
          }
          this.isDhcpEnabled = data["IsDhcpEnabled"] !== undefined ? data["IsDhcpEnabled"] : <any>null;
      }
  }

  static fromJS(data: any): IPAddr {
      let result = new IPAddr();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.addresses && this.addresses.constructor === Array) {
          data["Addresses"] = [];
          for (let item of this.addresses)
              data["Addresses"].push(item.toJSON());
      }
      if (this.staticAddresses && this.staticAddresses.constructor === Array) {
          data["StaticAddresses"] = [];
          for (let item of this.staticAddresses)
              data["StaticAddresses"].push(item.toJSON());
      }
      data["StaticDefaultGateway"] = this.staticDefaultGateway !== undefined ? this.staticDefaultGateway : <any>null;
      data["DefaultGateway"] = this.defaultGateway !== undefined ? this.defaultGateway : <any>null;
      if (this.dnsServers && this.dnsServers.constructor === Array) {
          data["DnsServers"] = [];
          for (let item of this.dnsServers)
              data["DnsServers"].push(item);
      }
      if (this.staticDns && this.staticDns.constructor === Array) {
          data["StaticDns"] = [];
          for (let item of this.staticDns)
              data["StaticDns"].push(item);
      }
      data["IsDhcpEnabled"] = this.isDhcpEnabled !== undefined ? this.isDhcpEnabled : <any>null;
      return data;
  }
}

export interface IIPAddr {
  addresses?: Addresses[];
  staticAddresses?: Addresses[];
  staticDefaultGateway?: string;
  defaultGateway?: string;
  dnsServers?: string[];
  staticDns?: string[];
  isDhcpEnabled?: boolean;
}

export class Addresses implements IAddresses {
  address?: string;
  subnetMask?: string;

  constructor(data?: IAddresses) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.address = data["Address"] !== undefined ? data["Address"] : <any>null;
          this.subnetMask = data["SubnetMask"] !== undefined ? data["SubnetMask"] : <any>null;
      }
  }

  static fromJS(data: any): Addresses {
      let result = new Addresses();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["Address"] = this.address !== undefined ? this.address : <any>null;
      data["SubnetMask"] = this.subnetMask !== undefined ? this.subnetMask : <any>null;
      return data;
  }
}

export interface IAddresses {
  address?: string;
  subnetMask?: string;
}

export class ScheduledActionsResult implements IScheduledActionsResult {
  result?: { [key: string] : ActionsStatus; };

  constructor(data?: IScheduledActionsResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          if (data["Result"]) {
              this.result = {};
              for (let key in data["Result"]) {
                  if (data["Result"].hasOwnProperty(key))
                      this.result[key] = data["Result"][key] ? ActionsStatus.fromJS(data["Result"][key]) : new ActionsStatus();
              }
          }
      }
  }

  static fromJS(data: any): ScheduledActionsResult {
      let result = new ScheduledActionsResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.result) {
          data["Result"] = {};
          for (let key in this.result) {
              if (this.result.hasOwnProperty(key))
                  data["Result"][key] = this.result[key] ? this.result[key].toJSON() : <any>null;
          }
      }
      return data;
  }
}

export interface IScheduledActionsResult {
  result?: { [key: string] : ActionsStatus; };
}

export class ActionsStatus implements IActionsStatus {
  lastRunTime?: Date;
  isSuccessful: boolean;

  constructor(data?: IActionsStatus) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.lastRunTime = data["LastRunTime"] ? new Date(data["LastRunTime"].toString()) : <any>null;
          this.isSuccessful = data["IsSuccessful"] !== undefined ? data["IsSuccessful"] : <any>null;
      }
  }

  static fromJS(data: any): ActionsStatus {
      let result = new ActionsStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["LastRunTime"] = this.lastRunTime ? this.lastRunTime.toISOString() : <any>null;
      data["IsSuccessful"] = this.isSuccessful !== undefined ? this.isSuccessful : <any>null;
      return data;
  }
}

export interface IActionsStatus {
  lastRunTime?: Date;
  isSuccessful: boolean;
}

export class DeviceLicenseRequest implements IDeviceLicenseRequest {
  licenses?: LicenseData[];
  activityLogs?: ActivityLog[];

  constructor(data?: IDeviceLicenseRequest) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          if (data["licenses"] && data["licenses"].constructor === Array) {
              this.licenses = [];
              for (let item of data["licenses"])
                  this.licenses.push(LicenseData.fromJS(item));
          }
          if (data["activityLogs"] && data["activityLogs"].constructor === Array) {
              this.activityLogs = [];
              for (let item of data["activityLogs"])
                  this.activityLogs.push(ActivityLog.fromJS(item));
          }
      }
  }

  static fromJS(data: any): DeviceLicenseRequest {
      let result = new DeviceLicenseRequest();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (this.licenses && this.licenses.constructor === Array) {
          data["licenses"] = [];
          for (let item of this.licenses)
              data["licenses"].push(item.toJSON());
      }
      if (this.activityLogs && this.activityLogs.constructor === Array) {
          data["activityLogs"] = [];
          for (let item of this.activityLogs)
              data["activityLogs"].push(item.toJSON());
      }
      return data;
  }
}

export interface IDeviceLicenseRequest {
  licenses?: LicenseData[];
  activityLogs?: ActivityLog[];
}

export class ActivityLog implements IActivityLog {
  id: string;
  accountId?: string;
  objectId?: string;
  objectName?: string;
  deviceModelType?: string;
  created: Date;
  correlationId: string;
  userId?: string;
  userName?: string;
  logType: ActivityLogType;
  targetObject?: string;
  property?: string;
  originalValue?: any;
  updatedValue?: any;
  actualValue?: any;
  displayedValue?: string;
  snapshottedObject?: any;

  constructor(data?: IActivityLog) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(data?: any) {
      if (data) {
          this.id = data["id"] !== undefined ? data["id"] : <any>null;
          this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
          this.objectId = data["ObjectId"] !== undefined ? data["ObjectId"] : <any>null;
          this.objectName = data["ObjectName"] !== undefined ? data["ObjectName"] : <any>null;
          this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
          this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
          this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
          this.userId = data["UserId"] !== undefined ? data["UserId"] : <any>null;
          this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
          this.logType = data["LogType"] !== undefined ? data["LogType"] : <any>null;
          this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
          this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
          this.originalValue = data["OriginalValue"] !== undefined ? data["OriginalValue"] : <any>null;
          this.updatedValue = data["UpdatedValue"] !== undefined ? data["UpdatedValue"] : <any>null;
          this.actualValue = data["ActualValue"] !== undefined ? data["ActualValue"] : <any>null;
          this.displayedValue = data["DisplayedValue"] !== undefined ? data["DisplayedValue"] : <any>null;
          this.snapshottedObject = data["SnapshottedObject"] !== undefined ? data["SnapshottedObject"] : <any>null;
      }
  }

  static fromJS(data: any): ActivityLog {
      let result = new ActivityLog();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
      data["ObjectId"] = this.objectId !== undefined ? this.objectId : <any>null;
      data["ObjectName"] = this.objectName !== undefined ? this.objectName : <any>null;
      data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
      data["Created"] = this.created ? this.created.toISOString() : <any>null;
      data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
      data["UserId"] = this.userId !== undefined ? this.userId : <any>null;
      data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
      data["LogType"] = this.logType !== undefined ? this.logType : <any>null;
      data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
      data["Property"] = this.property !== undefined ? this.property : <any>null;
      data["OriginalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
      data["UpdatedValue"] = this.updatedValue !== undefined ? this.updatedValue : <any>null;
      data["ActualValue"] = this.actualValue !== undefined ? this.actualValue : <any>null;
      data["DisplayedValue"] = this.displayedValue !== undefined ? this.displayedValue : <any>null;
      data["SnapshottedObject"] = this.snapshottedObject !== undefined ? this.snapshottedObject : <any>null;
      return data;
  }
}

export interface IActivityLog {
  id: string;
  accountId?: string;
  objectId?: string;
  objectName?: string;
  deviceModelType?: string;
  created: Date;
  correlationId: string;
  userId?: string;
  userName?: string;
  logType: ActivityLogType;
  targetObject?: string;
  property?: string;
  originalValue?: any;
  updatedValue?: any;
  actualValue?: any;
  displayedValue?: string;
  snapshottedObject?: any;
}

export enum ActivityLogType {
  Device = 0,
  Group = 1,
  License = 2,
  Firmware = 3,
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
  super();

      this.message = message;
      this.status = status;
      this.response = response;
  this.headers = headers;
      this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
      return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if(result !== null && result !== undefined)
      return Observable.throw(result);
  else
      return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
      let reader = new FileReader();
      reader.onload = function() {
          observer.next(this.result);
          observer.complete();
      }
      reader.readAsText(blob);
  });
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.LicenseClient.ts